/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

var _a;
var isWeb = typeof window !== 'undefined' && 'onload' in window;
typeof dd !== 'undefined' && !!dd && typeof dd.showtoast === 'function';
var isMiniAli = typeof my !== 'undefined' && !!my && (typeof my.showToast === 'function' || typeof my.navigateTo === 'function');
var isMiniTt = typeof tt !== 'undefined' && !!tt && typeof tt.showtoast === 'function';
var isMiniWx = !isMiniTt &&
    typeof wx !== 'undefined' &&
    !!wx &&
    (typeof wx.login !== 'undefined' || typeof wx.miniProgram !== 'undefined');
var isMini = isMiniAli || isMiniWx || isMiniTt;
typeof WXEnvironment !== 'undefined' &&
    !!WXEnvironment &&
    WXEnvironment.platform !== 'Web';
var aliUA = '';
try {
    aliUA = navigator.userAgent || navigator.swuserAgent || '';
}
catch (error) {
    aliUA = '';
}
var isMiniweb = (isWeb && aliUA.indexOf('Triver') > -1) || aliUA.indexOf('miniProgram') > -1;
var aliAppMatches = /.+AliApp\((\w+)\/((?:\d+\.)+\d+)\)/.exec(aliUA || '') || [];
var client = (_a = aliAppMatches[1]) === null || _a === void 0 ? void 0 : _a.toLocaleLowerCase();
var isWindvane = /.+AliApp\((\w+)\/((?:\d+\.)+\d+)\).* .*(WindVane)(?:\/((?:\d+\.)+\d+))?.*/.test(aliUA || '');
var isNebula = /.+AliApp\((\w+)\/((?:\d+\.)+\d+)\)/.test(aliUA || '') &&
    /.*(Nebula)(?:\/((?:\d+\.)+\d+))?.*/.test(aliUA || '');
var isFliggy = /.+AliApp\((\w+)\/((?:\d+\.)+\d+)\) .*(AliTrip)(?:\/((?:\d+\.)+\d+))?.*/.test(aliUA || '');
var isDingTalk = /.+AliApp\((DingTalk)\/((?:\d+\.)+\d+)?.*/.test(aliUA || '');
var isWebTm = isWeb && client === 'tm';
var isWebFm = isWeb && client === 'fm';
var isWebLt = isWeb && client === 'lt';
var isWebTb = isWeb && client === 'tb';
var isWebElmc = isWeb && client === 'elmc';
var isWebIhome = isWeb && client === 'ihome';
var isWebTphome = isWeb && client === 'tphome';
var isWebQn = isWeb && client === 'qn';
var isWebYouku = isWeb && client === 'youku';
var isWebWdkhema = isWeb && client === 'wdkhema';
var isWebCunpartner = isWeb && client === 'cunpartner';
var isWebAh = isWeb && client === 'ah';
var isWebAlipm = isWeb && client === 'alipm';
var isDingTalkPC = /\s+DingTalk\(/i.test(aliUA);
var isAndroid = aliUA.indexOf('Android') > -1 || aliUA.indexOf('Adr') > -1;
var isIOS = !!aliUA.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
function isIphoneXSeries() {
    var deviceHeight = screen.height * window.devicePixelRatio;
    if (['2340', '2436', '2688', '1792', '1624', '2532', '2778'].indexOf(String(deviceHeight)) >= 0) {
        return true;
    }
}

function notSupport(_a) {
    var fail = _a.fail;
    fail({
        errCode: '1',
        errMsg: 'not support',
    });
}
function enhanceSuccess(success, _originalInput, formatOptions, formatErrorOptions) {
    if (success === void 0) { success = function (ret) { return ret; }; }
    if (formatOptions === void 0) { formatOptions = {}; }
    if (formatErrorOptions === void 0) { formatErrorOptions = {}; }
    var formatOutput = formatOptions.formatOutput, outputMap = formatOptions.outputMap;
    return function (ret) {
        var _a;
        if (ret && ret.error) {
            var onFail = enhanceFail(_originalInput && _originalInput.fail, formatErrorOptions);
            return onFail(ret);
        }
        var output = {};
        if (typeof formatOutput === 'function') {
            output = formatOutput(ret);
        }
        else if (outputMap) {
            (_a = Object.keys(outputMap)) === null || _a === void 0 ? void 0 : _a.forEach(function (key) {
                output[key] = ret[outputMap[key]];
            });
        }
        output = __assign(__assign({}, ret), output);
        outputMap && delete outputMap.ret;
        outputMap && delete outputMap.status;
        success(__assign(__assign({}, output), { _original: {
                input: _originalInput,
                output: ret,
            } }));
    };
}
function enhanceFail(fail, formatOptions) {
    if (fail === void 0) { fail = function (e) { return e; }; }
    if (formatOptions === void 0) { formatOptions = {}; }
    return function (e) {
        var _a;
        var formatOutput = formatOptions.formatOutput, outputMap = formatOptions.outputMap;
        var output = {};
        if (typeof formatOutput === 'function') {
            output = formatOutput(e);
        }
        else if (outputMap) {
            (_a = Object.keys(outputMap)) === null || _a === void 0 ? void 0 : _a.forEach(function (key) {
                output[key] = e[outputMap[key]];
            });
        }
        output = __assign(__assign({}, e), output);
        outputMap && delete outputMap.ret;
        outputMap && delete outputMap.status;
        return fail(__assign({ _originalErrInfo: e }, output));
    };
}
function apiCall(apiName, params, JSCall, formatOptions, errFormatOptions) {
    var _a;
    if (formatOptions === void 0) { formatOptions = {}; }
    if (errFormatOptions === void 0) { errFormatOptions = {}; }
    var success = params.success, fail = params.fail;
    var options = {};
    var formatInput = formatOptions.formatInput, inputMap = formatOptions.inputMap, formatOutput = formatOptions.formatOutput, outputMap = formatOptions.outputMap;
    if (typeof formatInput === 'function') {
        options = formatInput(params);
    }
    else if (inputMap) {
        (_a = Object.keys(inputMap)) === null || _a === void 0 ? void 0 : _a.forEach(function (key) {
            options[key] = params[inputMap[key]];
        });
    }
    options = __assign(__assign({}, params), options);
    var onSuccess = enhanceSuccess(success, options, {
        outputMap: outputMap,
        formatOutput: formatOutput,
    }, errFormatOptions);
    var onFail = enhanceFail(fail, errFormatOptions);
    apiName
        ? JSCall(apiName, options, onSuccess, onFail)
        : JSCall(__assign(__assign({}, options), { onSuccess: onSuccess, onFail: onFail }));
}
function promisifyApi(apiFn, plugins) {
    var promisify = function (apiFn) { return function (params) {
        if (params === void 0) { params = {}; }
        return new Promise(function (resolve, reject) {
            var success = function (e) {
                if (typeof params.success === 'function') {
                    params.success(e);
                }
                else {
                    resolve(e);
                }
            };
            var fail = function (e) {
                typeof params.fail === 'function' && params.fail(e);
                reject(e);
            };
            if (!params.onSuccess) {
                params.onSuccess = success;
            }
            if (!params.onFail) {
                params.onFail = fail;
            }
            apiFn(__assign(__assign({}, params), { success: success, fail: fail }));
        });
    }; };
    var api = promisify(apiFn);
    return api;
}
function search2JSON(search) {
    if (search === void 0) { search = ''; }
    var queryArr = search.replace(/^\?/, '').split(/&+/);
    var params;
    queryArr.forEach(function (item) {
        var index = item.indexOf('=');
        var key = item.substr(0, index);
        var value = item.substring(index + 1);
        if (key) {
            if (!params) {
                params = {};
            }
            params[key] = decodeURIComponent(value);
        }
    });
    return params;
}
function parse(url) {
    if (url === void 0) { url = ''; }
    var REG = /^((https?:)?(?:\/{2})?(([^:/]+?\.[^:/?]+)(?::(\d+))?)?)([^?#]*)([^#]*)(#.*)?/i;
    var matches = url.match(REG);
    var params = search2JSON((matches === null || matches === void 0 ? void 0 : matches[7]) || '');
    return {
        href: matches === null || matches === void 0 ? void 0 : matches[0],
        origin: matches === null || matches === void 0 ? void 0 : matches[1],
        protocol: matches === null || matches === void 0 ? void 0 : matches[2],
        host: matches === null || matches === void 0 ? void 0 : matches[3],
        hostname: matches === null || matches === void 0 ? void 0 : matches[4],
        port: matches === null || matches === void 0 ? void 0 : matches[5],
        pathname: matches === null || matches === void 0 ? void 0 : matches[6],
        search: matches === null || matches === void 0 ? void 0 : matches[7],
        hash: matches === null || matches === void 0 ? void 0 : matches[8],
        params: params,
    };
}
function object2search(obj) {
    var _obj = Object.assign({}, obj, { '//': '//' });
    var keys = ['protocol', '//', 'host', 'pathname', 'params', 'hash'];
    var result = '';
    keys.forEach(function (key) {
        if (key === 'params' && _obj.params) {
            var parArr = [];
            var _params = Object.assign({}, _obj.params);
            for (var k in _params) {
                if (!_params.hasOwnProperty(k)) {
                    continue;
                }
                parArr.push(k + '=' + encodeURIComponent(_params[k]));
            }
            result += '?' + parArr.join('&');
        }
        else {
            if (!obj.hostname && key === '//') {
                return false;
            }
            result += _obj[key] || '';
        }
    });
    return result;
}
function setSearch(url, params, newHash) {
    if (newHash === void 0) { newHash = ''; }
    if (!url) {
        return '';
    }
    var result = parse(url);
    result.params = Object.assign(result.params || {}, params);
    if (newHash) {
        result.hash = (/^#/.test(newHash) ? '' : '#') + newHash;
    }
    return object2search(result);
}

var ERR_SCAN_USER_CANCEL = '10';
var ERR_USER_CANCEL = '11';
var ERROR_AUDIO_CONFIG = '12';
var ERR_COMMON = '11';
var ERR_MSG_CANCEL = 'cancel';
var ERR_MSG_COMMON = 'call failed';
var ERR_MSG_AUDIO_CONFIG = 'audio config not found';

var JSCall$1 = function (api, options, success, failure) {
    if (success === void 0) { success = function (r) { }; }
    if (failure === void 0) { failure = function (e) { }; }
    if (typeof options === 'function') {
        failure = success;
        success = options;
        options = {};
    }
    if (!__windvane__.call) {
        new Function(__windvane__.windVaneCoreJs())();
    }
    __windvane__.call(api, options, success, failure);
};
function WVCall(apiName, params, formatOptions, errFormatOptions) {
    if (formatOptions === void 0) { formatOptions = {}; }
    if (errFormatOptions === void 0) { errFormatOptions = {}; }
    apiCall(apiName, params, JSCall$1, formatOptions, errFormatOptions);
}
function alert$a(params) {
    var api = 'WVUIDialog.alert';
    var title = params.title, content = params.content, _a = params.buttonText, buttonText = _a === void 0 ? '确定' : _a, _b = params.success, success = _b === void 0 ? function (r) { return r; } : _b, _c = params.fail, fail = _c === void 0 ? function (e) { return e; } : _c;
    var options = __assign(__assign({}, params), { title: title, message: content, okbutton: buttonText, identifier: Date.now() });
    var onSuccess = enhanceSuccess(success, options);
    var onFail = enhanceFail(fail);
    var handler = function (e) {
        if ((e.identifier || e.param.identifier) == options.identifier) {
            onSuccess(e);
            document.removeEventListener('WV.Event.Alert', handler);
        }
    };
    document.addEventListener('WV.Event.Alert', handler, false);
    JSCall$1(api, options, function () { }, onFail);
}
function chooseImage$8(params) {
    var formatInput = function (options) {
        var _a, _b;
        var mode = 'both';
        var sourceTypeInlcudeCamera = ((_a = options.sourceType) === null || _a === void 0 ? void 0 : _a.indexOf('camera')) > -1;
        var sourceTypeInlcudePhoto = ((_b = options.sourceType) === null || _b === void 0 ? void 0 : _b.indexOf('album')) > -1;
        if (sourceTypeInlcudeCamera || sourceTypeInlcudePhoto) {
            if (sourceTypeInlcudeCamera) {
                mode = 'camera';
            }
            if (sourceTypeInlcudePhoto) {
                mode = 'photo';
            }
        }
        return {
            type: '0',
            v: '2.0',
            mode: mode,
            mutipleSelection: options.multipleSelection || '0',
            bizCode: 'mtopupload',
            needLogin: false,
            maxSelect: options.count || 1,
        };
    };
    var formatOutput = function (ret) {
        var images = ret.images;
        return params.multipleSelection == '1'
            ? {
                tempFilePaths: images.map(function (image) { return image.localPath; }),
                tempFiles: images.map(function (image) {
                    return {
                        path: image.localPath,
                        previewURL: image.url,
                    };
                }),
            }
            : {
                tempFilePaths: [ret.localPath],
                tempFiles: [
                    {
                        path: ret.localPath,
                        previewURL: ret.url,
                    },
                ],
            };
    };
    var errFormatOutput = function (error) {
        var errorCode = error.status === 'RET_PHOTO_CANCEL' ? ERR_USER_CANCEL : ERR_COMMON;
        var errorMsg = error.msg === 'RET_PHOTO_CANCEL' ? ERR_MSG_CANCEL : ERR_MSG_COMMON;
        return {
            error: errorCode,
            errorMsg: errorMsg,
        };
    };
    return WVCall('WVCamera.takePhoto', params, {
        formatInput: formatInput,
        formatOutput: formatOutput,
    }, { formatOutput: errFormatOutput });
}
function uploadImage$3(params) {
    var files = params.tempFiles || params.files;
    if (files && files.length && files[0].path) {
        var urlList_1 = [];
        var originalRes_1 = [];
        files
            .reduce(function (promise, file) {
            return promise.then(function () {
                return new Promise(function (resolve1, reject1) {
                    var options = {
                        path: file.path,
                        v: '2.0',
                        bizCode: params.bizCode || 'mtopupload',
                        needLogin: false,
                    };
                    var onSuccess = function (ret) {
                        urlList_1.push(ret.resourceURL);
                        originalRes_1.push(ret);
                        resolve1();
                    };
                    var onFail = function (e) {
                        reject1(e);
                    };
                    JSCall$1('WVCamera.confirmUploadPhoto', options, onSuccess, onFail);
                });
            });
        }, Promise.resolve())
            .then(function () {
            var success = params.success;
            var onSuccess = enhanceSuccess(success, {});
            onSuccess({
                urlList: urlList_1,
                _original: { output: originalRes_1 },
            });
        })
            .catch(function (error) {
            var onFail = enhanceFail(params.fail);
            return onFail(error);
        });
    }
}
function showLoading$a(params) {
    WVCall('WVUI.showLoadingBox', params);
}
function choosePhoneContact$9(params) {
    var formatOutput = function (ret) {
        return {
            name: ret.name,
            phone: ret.phone.replace(/(\s|-)+/g, ''),
        };
    };
    var errFormatOutput = function (error) {
        var errorCode = error.msg === 'User abort' ? ERR_USER_CANCEL : ERR_COMMON;
        var errorMsg = error.msg === 'User abort' ? ERR_MSG_CANCEL : ERR_MSG_COMMON;
        return {
            error: errorCode,
            errorMsg: errorMsg,
        };
    };
    WVCall('WVContacts.choose', params, { formatOutput: formatOutput }, { formatOutput: errFormatOutput });
}
function confirm$8(params) {
    var api = 'WVUIDialog.confirm';
    var title = params.title, content = params.content, _a = params.confirmButtonText, confirmButtonText = _a === void 0 ? '确定' : _a, _b = params.cancelButtonText, cancelButtonText = _b === void 0 ? '取消' : _b, _c = params.success, success = _c === void 0 ? function (ret) { return ret; } : _c, _d = params.fail, fail = _d === void 0 ? function (err) { return err; } : _d;
    var options = __assign(__assign({}, params), { title: title, message: content, okbutton: confirmButtonText, canclebutton: cancelButtonText, _index: Date.now() });
    var formatOutput = function (ret) {
        var r = ret.param;
        if (r._index == options._index) {
            return {
                confirm: r.type === options.okbutton,
            };
        }
    };
    var onSuccess = enhanceSuccess(success, options, { formatOutput: formatOutput });
    var handler = function (e) {
        var r = e.param;
        if (r._index == options._index) {
            onSuccess(e);
            document.removeEventListener('wv.dialog', handler);
        }
    };
    document.addEventListener('wv.dialog', handler, false);
    JSCall$1(api, options, function () { }, fail);
}
function getLocation$a(params) {
    var options = {
        address: true,
    };
    var onFail = enhanceFail(params.fail);
    var formatOutput = function (res) {
        var coords = res.coords, address = res.address;
        return __assign(__assign({}, coords), address);
    };
    var onSuccess = function (ret) {
        var _success = enhanceSuccess(params === null || params === void 0 ? void 0 : params.success, options, { formatOutput: formatOutput });
        try {
            _success(ret);
        }
        catch (e) {
            onFail(e);
        }
    };
    JSCall$1('WVLocation.getLocation', params, onSuccess, onFail);
}
function getNetworkType$a(params) {
    var formatOutput = function (ret) {
        var type = "" + ret.type;
        switch (type) {
            case 'WIFI':
            case '4G':
            case '3G':
            case '2G':
                break;
            case 'CELL':
            case 'UNKNOWN':
            default:
                type = 'UNKNOWN';
                break;
        }
        return { networkType: type };
    };
    WVCall('WVNetwork.getNetworkType', params, { formatOutput: formatOutput });
}
function getOrientation$3(params) {
    var outputMap = {
        orientation: 'orientation',
    };
    WVCall('WVScreen.getOrientation', params, { outputMap: outputMap });
}
function hideLoading$9(params) {
    WVCall('WVUI.hideLoadingBox', params);
}
function isAppInstalled$5(params) {
    var formatInput = function (options) {
        return {
            installed: {
                android: options.android,
                ios: options.ios,
            },
        };
    };
    var formatOutput = function (res) {
        return {
            installed: isIOS ? res.installed : res.installed === '0' ? false : true,
        };
    };
    WVCall('Base.isAppsInstalled', params, { formatInput: formatInput, formatOutput: formatOutput });
}
function openInBrowser$3(params) {
    WVCall('Base.openBrowser', params);
}
function setBackgroundColor$5(params) {
    var formatInput = function (options) {
        return {
            color: options.backgroundColor,
            alpha: options.alpha || 1,
        };
    };
    WVCall('Base.setBackgroundColor', params, { formatInput: formatInput });
}
function setClipboard$9(params) {
    WVCall('Base.copyToClipboard', params);
}
function setOrientation$1(params) {
    WVCall('WVScreen.setOrientation', params);
}
function showActionSheet$9(params) {
    var api = 'WVUIActionSheet.show';
    var _a = params.cancelButtonText, cancelButtonText = _a === void 0 ? '取消' : _a, items = params.items, success = params.success, fail = params.fail;
    var options = __assign(__assign({}, params), { cancelBtn: cancelButtonText, buttons: items });
    var formatOutput = function (ret) {
        var index = -1;
        items.some(function (btn, key) {
            if (ret.param.type === btn) {
                index = key;
                return false;
            }
        });
        return { index: index };
    };
    var _success = enhanceSuccess(success, options, { formatOutput: formatOutput });
    var onSuccess = function (e) {
        var onActionSheetClick = function (ret) {
            _success(ret);
            document.removeEventListener('wv.actionsheet', onActionSheetClick);
        };
        document.addEventListener('wv.actionsheet', onActionSheetClick, false);
    };
    var onFail = typeof fail === 'function' ? function (e) { return fail(e); } : function (e) { return e; };
    JSCall$1(api, options, onSuccess, onFail);
}
function snapshot$3(params) {
    var formatInput = function (options) {
        return { inAlbum: options.saveToGallery ? 'true' : 'false', type: false };
    };
    WVCall('WVScreen.capture', params, { formatInput: formatInput });
}
function vibrate$7(params) {
    WVCall('WVMotion.vibrate', params);
}
function redirectTo$8(params) {
    var formatInput = function (options) {
        return {
            url: options.url,
            popBeforeOpen: true,
        };
    };
    WVCall('WVNative.openWindow', params, { formatInput: formatInput });
}
function setNavigationBar$f(params) {
    var formatInput = function (options) {
        var title = options.title, subtitle = options.subtitle, image = options.image;
        var formattedOptions = {
            title: title,
            subtitle: '',
            icon: '',
            iconType: '',
        };
        if (subtitle) {
            formattedOptions.subtitle = subtitle;
        }
        if (image) {
            formattedOptions.icon = image;
            formattedOptions.iconType = 'URL';
        }
        return formattedOptions;
    };
    WVCall('WebAppInterface.setCustomPageTitle', params, {
        formatInput: formatInput,
    });
}
function showToast$9(params) {
    var formatInput = function (options) {
        var content = options.content, _a = options.type, type = _a === void 0 ? 'none' : _a, _b = options.duration, duration = _b === void 0 ? 1500 : _b;
        return {
            type: type,
            content: content,
            duration: Math.round(duration / 1000),
            message: content,
        };
    };
    WVCall('WVUIToast.toast', params, { formatInput: formatInput });
}
function saveImage$5(params) {
    WVCall('WVImage.saveImage', params);
}
function getStatusBarHeight$5(params) {
    if (isAndroid) {
        return notSupport(params === null || params === void 0 ? void 0 : params.fail);
    }
    return params === null || params === void 0 ? void 0 : params.success({ statusBarHeight: isIphoneXSeries ? 88 : 40 });
}

var readyCall = function (fn) {
    if (window.AlipayJSBridge) {
        fn();
    }
    else {
        var _once_1 = function () {
            fn();
            document.removeEventListener('AlipayJSBridgeReady', _once_1, false);
        };
        document.addEventListener('AlipayJSBridgeReady', _once_1, false);
    }
};
var call = function (api, options, success, failure) {
    if (typeof options === 'function') {
        failure = success;
        success = options;
        options = {};
    }
    readyCall(function () {
        AlipayJSBridge.call(api, options, success, failure);
    });
};

function NBCall(apiName, params, formatOptions, errFormatOptions) {
    if (formatOptions === void 0) { formatOptions = {}; }
    if (errFormatOptions === void 0) { errFormatOptions = {}; }
    apiCall(apiName, params, call, formatOptions, errFormatOptions);
}
function showLoading$9(params) {
    NBCall('showLoading', params);
}
function chooseCity$4(params) {
    NBCall('getCities', params);
}
function choosePhoneContact$8(params) {
    var formatOutput = function (ret) {
        return {
            name: ret.name,
            phone: ret.mobile.replace(/(\s|-)+/g, ''),
        };
    };
    NBCall('contact', params, { formatOutput: formatOutput });
}
function getDeviceId$5(params) {
    var outputMap = {
        deviceId: 'device.id',
    };
    NBCall('getClientInfo', params, { outputMap: outputMap });
}
function clearNaviBarRightItem$6(params) {
    var formatOutput = function () {
        return { reset: true };
    };
    NBCall('setOptionMenu', params, { formatOutput: formatOutput });
    if (!params.show) {
        call('hideOptionMenu');
    }
    else {
        call('showOptionMenu');
    }
}
function getNetworkType$9(params) {
    var formatOutput = function (ret) {
        var type = "" + ret.type;
        switch (type) {
            case 'WIFI':
            case '4G':
            case '3G':
            case '2G':
                break;
            case 'NOTREACHABLE':
                type = 'NONE';
                break;
            case 'UNKNOWN':
            case 'WWAN':
            default:
                type = 'UNKNOWN';
                break;
        }
        return { networkType: type };
    };
    NBCall('getNetworkType', params, { formatOutput: formatOutput });
}
function hideLoading$8(params) {
    NBCall('hideLoading', params);
}
function isAppInstalled$4(params) {
    var formatInput = function (input) {
        return {
            scheme: input.ios,
            packagename: input.android,
        };
    };
    NBCall('isInstalledApp', params, { formatInput: formatInput });
}
function navigateBack$e(params) {
    NBCall('popWindow', params);
}
function openInBrowser$2(params) {
    NBCall('openInBrowser', params);
}
function previewImage$9(params) {
    var api = 'imageViewer';
    var formatInput = function (options) {
        var _a = options.current, current = _a === void 0 ? 0 : _a, _b = options.urls, urls = _b === void 0 ? [] : _b;
        var formattedOptions = {
            images: [],
            init: +(current || 0),
        };
        urls.forEach(function (url) {
            formattedOptions.images.push({
                u: url,
                t: '',
            });
        });
        return formattedOptions;
    };
    NBCall(api, params, { formatInput: formatInput });
}
function scan$b(params) {
    var formatInput = function (_a) {
        var _b = _a.scanType, scanType = _b === void 0 ? ['qrCode', 'barCode'] : _b, _c = _a.hideAlbum, hideAlbum = _c === void 0 ? false : _c;
        return {
            scanType: scanType,
            hideAlbum: hideAlbum,
        };
    };
    var errFormatOutput = function (error) {
        var errorMsg = error.error === ERR_SCAN_USER_CANCEL ? ERR_MSG_CANCEL : ERR_MSG_COMMON;
        return {
            errorMsg: errorMsg,
        };
    };
    NBCall('scan', params, { formatInput: formatInput }, { formatOutput: errFormatOutput });
}
function setClipboard$8(params) {
    NBCall('setClipboard', params);
}
function setNaviBarRightItem$6(params) {
    var formatInput = function (input) {
        var type = input.type, title = input.title, iconBase64 = input.iconBase64;
        var options = {
            redDot: '-1',
            reset: false,
            override: false,
        };
        if (type === 'text') {
            options.color = '#FF1478E3';
            options.title = title;
        }
        if (type === 'icon') {
            options.icon = iconBase64;
        }
        return options;
    };
    if (!window._uniapi_context) {
        window._uniapi_context = {};
    }
    if (!window._uniapi_context.events) {
        window._uniapi_context.events = {};
    }
    var lastHandler = window._uniapi_context.events.setNaviBarRightItem;
    if (typeof lastHandler === 'function') {
        document.removeEventListener('optionMenu', lastHandler);
    }
    var handler = params.onClick || function () { };
    document.addEventListener('optionMenu', handler, false);
    NBCall('setOptionMenu', params, { formatInput: formatInput });
    call('showOptionMenu');
}
function showActionSheet$8(params) {
    var formatInput = function (_a) {
        var _b = _a.cancelButtonText, cancelButtonText = _b === void 0 ? '取消' : _b, _c = _a.items, items = _c === void 0 ? [] : _c;
        return {
            cancelBtn: cancelButtonText,
            buttons: items,
            btns: items,
        };
    };
    NBCall('actionSheet', params, { formatInput: formatInput });
}
function showSharePanel$e(params) {
    NBCall('startShare', params);
}
function snapshot$2(params) {
    var formatInput = function (_a) {
        var _b = _a.saveToGallery, saveToGallery = _b === void 0 ? true : _b;
        return {
            dataType: 'fileURL',
            saveToGallery: saveToGallery,
        };
    };
    NBCall('snapshot', params, { formatInput: formatInput });
}
function vibrate$6(params) {
    NBCall('vibrate', params);
}
function alert$9(params) {
    var inputMap = {
        message: 'content',
        button: 'buttonText',
    };
    NBCall('alert', params, { inputMap: inputMap });
}
function confirm$7(params) {
    params.confirmButtonText = params.confirmButtonText || '确定';
    params.cancelButtonText = params.cancelButtonText || '取消';
    var inputMap = {
        message: 'content',
        okButton: 'confirmButtonText',
        cancelButton: 'cancelButtonText',
    };
    var outputMap = {
        confirm: 'ok',
    };
    NBCall('confirm', params, { inputMap: inputMap, outputMap: outputMap });
}
function getLocation$9(params) {
    var api = 'getLocation';
    var options = {
        requestType: true,
    };
    var _a = params.success, success = _a === void 0 ? function (r) { return r; } : _a, _b = params.fail, fail = _b === void 0 ? function (e) { return e; } : _b;
    var formatOutput = function (ret) {
        return {
            longitude: ret.longitude,
            latitude: ret.latitude,
            country: ret.country,
            countryCode: ret.countryCode,
            province: ret.province,
            city: ret.city.replace(/市$/i, ''),
            cityAdCode: ret.citycode,
        };
    };
    var onFail = enhanceFail(fail);
    var _success = enhanceSuccess(success, options, { formatOutput: formatOutput });
    var onSuccess = function (ret) {
        try {
            _success(ret);
        }
        catch (e) {
            onFail(e);
        }
    };
    call(api, options, onSuccess, onFail);
}
function navigateTo$f(params) {
    if (params === null || params === void 0 ? void 0 : params.useMiniCall) {
        var isMiniAli = typeof my !== 'undefined' &&
            !!my &&
            (typeof my.showToast === 'function' ||
                typeof my.navigateTo === 'function');
        if (isMiniAli) {
            return my === null || my === void 0 ? void 0 : my.navigateTo(params);
        }
    }
    NBCall('pushWindow', params);
}
function redirectTo$7(params) {
    var api = 'startApp';
    var formatInput = function (_a) {
        var url = _a.url;
        var options = {
            appId: '20000067',
            param: {
                url: url,
            },
            closeCurrentApp: true,
        };
        var matches = url.match(/\/\/([0-9]+).h5app/i);
        if (matches) {
            options = __assign(__assign({}, options), { appId: matches[1] });
        }
        return options;
    };
    NBCall(api, params, { formatInput: formatInput });
}
function setNavigationBar$e(params) {
    var api = 'setTitle';
    var formatInput = function (_a) {
        var title = _a.title, subtitle = _a.subtitle, image = _a.image, backgroundColor = _a.backgroundColor, reset = _a.reset;
        var options = {
            title: title,
        };
        if (subtitle) {
            options = __assign(__assign({}, options), { subtitle: subtitle });
        }
        options = __assign(__assign({}, options), { image: image });
        if (backgroundColor) {
            call('setTitleColor', {
                color: parseInt(backgroundColor, 16),
            });
        }
        if (reset) {
            call('setTitleColor', {
                reset: reset,
            });
        }
        return options;
    };
    NBCall(api, params, { formatInput: formatInput });
}
function showToast$8(_a) {
    var content = _a.content, _b = _a.type, type = _b === void 0 ? 'none' : _b, _c = _a.duration, duration = _c === void 0 ? 1500 : _c, _d = _a.success, success = _d === void 0 ? function (_) { return _; } : _d, _e = _a.fail, fail = _e === void 0 ? function () { } : _e;
    var api = 'toast';
    var options = {
        type: type,
        content: content,
        duration: duration,
    };
    var onSuccess = enhanceSuccess(success, options);
    var onFail = enhanceFail(fail);
    call(api, options, onSuccess, onFail);
    if (!/Android/i.test(navigator.userAgent)) {
        onSuccess(1);
    }
}
function chooseImage$7(params) {
    var formatInput = function () {
        return {
            publicDomain: true,
        };
    };
    var formatOutput = function (ret) {
        var formattedData = {
            tempFilePaths: [],
            tempFiles: [],
        };
        var previewURLList = ret.apFilePathsV2 || ret.apFilePaths;
        previewURLList.forEach(function (previewURL, index) {
            if (ret.localIds) {
                formattedData.tempFiles.push({
                    localId: ret.localIds[index],
                    previewURL: previewURL,
                });
                formattedData.tempFilePaths.push(previewURL);
            }
            if (ret.tempFilePaths) {
                var tempFilePaths = ret.tempFilePaths;
                if (typeof tempFilePaths === 'string') {
                    tempFilePaths = JSON.parse(tempFilePaths);
                }
                formattedData.tempFiles.push({
                    path: tempFilePaths[index],
                    previewURL: previewURL,
                });
                formattedData.tempFilePaths.push(tempFilePaths[index]);
            }
        });
        return formattedData;
    };
    NBCall('chooseImage', params, { formatInput: formatInput, formatOutput: formatOutput });
}
function uploadImage$2(params) {
    try {
        delete params.ex;
    }
    catch (error) { }
    var promises = [];
    var files = params.tempFiles || params.files;
    files.forEach(function (file) {
        promises.push(new Promise(function (resolve, reject) {
            var options = {
                compress: 4,
                business: params.business || 'NebulaBiz',
                publicDomain: true,
                dataType: '',
                data: '',
            };
            if (file.path) {
                options.dataType = 'fileURL';
                options.data = file.path;
            }
            else if (file.dataURL) {
                options.dataType = 'dataURL';
                options.data = file.dataURL;
            }
            else if (file.localId) {
                options.dataType = 'localID';
                options.data = file.localId;
            }
            else ;
            var onSuccess = function (ret) {
                if (ret.errorMessage) {
                    reject(ret);
                }
                else {
                    resolve(__assign(__assign(__assign({}, ret), ret.result), { _originalOutput: ret, _originalInput: options }));
                }
            };
            var onFail = function (e) { return reject(e); };
            call('uploadImage', options, onSuccess, onFail);
        }));
    });
    var success = params.success, fail = params.fail;
    var onSuccess = typeof success === 'function' ? function (ret) { return success(ret); } : function (ret) { return ret; };
    Promise.all(promises)
        .then(function (results) {
        var res = [];
        var originalRes = [];
        results.forEach(function (item) {
            res.push(item.publicUrl);
            originalRes.push(item);
        });
        onSuccess(__assign(__assign({}, params), { urlList: res, originalRes: originalRes, _originalOutput: originalRes }));
    })
        .catch(function (error) {
        fail(error);
    });
}
function playAudio$2(params) {
    var audioConfig = {
        audioDataUrl: params.urlMP3,
        audioName: 'audio-' + params.identifier,
        business: 'apm-h5',
    };
    if (!window._uniapi_context) {
        window._uniapi_context = {};
    }
    window._uniapi_context.audioConfig = audioConfig;
    var formatInput = function () {
        return audioConfig;
    };
    return stopAudio$2({
        identifier: params.identifier,
        success: function (res) {
            NBCall('playBackgroundAudio', params, { formatInput: formatInput });
        },
        fail: function () {
            NBCall('playBackgroundAudio', params, { formatInput: formatInput });
        },
    });
}
function pauseAudio$1(params) {
    return NBCall('pauseBackgroundAudio', params, {});
}
function stopAudio$2(params) {
    if (window._uniapi_context) {
        window._uniapi_context.audioConfig = null;
    }
    return NBCall('stopBackgroundAudio', params, {});
}
function resumeAudio$1(params) {
    if (window._uniapi_context) {
        var audioConfig = window._uniapi_context.audioConfig;
        if (!audioConfig) {
            return NBCall('playBackgroundAudio', audioConfig);
        }
    }
    var onFail = enhanceFail(params.fail);
    onFail({
        error: ERROR_AUDIO_CONFIG,
        errMsg: ERR_MSG_AUDIO_CONFIG,
    });
}
function getStatusBarHeight$4(params) {
    NBCall('getTitleAndStatusbarHeight', params);
}

var platform = '';
try {
    platform = /\(i[^;]+;( U;)? CPU.+Mac OS X/i.test(navigator.userAgent)
        ? 'iOS'
        : 'Android';
}
catch (error) { }
var JSCall = function () {
    var _a;
    var _b;
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    if (typeof window !== 'undefined' &&
        !!window &&
        typeof ((_b = window === null || window === void 0 ? void 0 : window.FYBridge) === null || _b === void 0 ? void 0 : _b.call) === 'function') {
        return (_a = window.FYBridge).call.apply(_a, __spread(args));
    }
    function genID() {
        return ~~(Math.random() * 1000);
    }
    var cMap = {
        successCallback: 'suc_',
        callbackCommand: 'cmd_',
        failCallback: 'fail_',
    };
    function genCallback(api, type, fn, isKeep) {
        var cname = ("" + (isKeep ? 'e_handler_' : api + "_" + (cMap[type] || 'callback_')) + genID()).replace(/\//gi, '_');
        window[cname] = (function (cb, _cname) {
            return function () {
                var rest = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    rest[_i] = arguments[_i];
                }
                cb.apply(void 0, __spread(rest));
                if (!isKeep) {
                    delete window[_cname];
                }
            };
        })(fn, cname);
        return cname;
    }
    var FYBridge = window.FYBridge;
    if (!FYBridge) {
        var pushBack_1 = function (api, params, isKeep) {
            if (params === void 0) { params = {}; }
            var name = 'bridge';
            var action = "bridge://" + api;
            var isAbnormal = /:\/\//.test(api);
            if (isAbnormal) {
                action = api;
                var _arr = api.split('://');
                name = _arr[0];
                api = _arr[1];
            }
            for (var i in params) {
                if (Object.prototype.hasOwnProperty.call(params, i)) {
                    if (typeof params[i] === 'function') {
                        params[i] = genCallback(api, i, params[i], isKeep);
                    }
                    var formattedKey = params.ignore2LowerCase
                        ? i
                        : i.replace(/([A-Z])/g, '_$1').toLowerCase();
                    if (i !== formattedKey) {
                        params[formattedKey] = params[i];
                        delete params[i];
                    }
                }
            }
            if (platform === 'iOS') {
                if (/\bWK\b/i.test(navigator.userAgent)) {
                    params._action_ = api;
                    webkit.messageHandlers[name].postMessage(params);
                }
                else {
                    alitripNativeCall(action, params);
                }
            }
            else {
                __JSContext__.alitripNativeCall(action, JSON.stringify(params));
            }
        };
        var call = function (api, options, success, failure) {
            if (typeof options === 'function') {
                failure = success;
                success = options;
                options = {};
            }
            if (success) {
                options.callbackCommand = options.successCallback = success;
            }
            if (failure) {
                options.failCallback = failure;
            }
            if (options.clickHandler || options.clickCallback) {
                pushBack_1(api, options, true);
            }
            else {
                pushBack_1(api, options);
            }
        };
        FYBridge = { version: '1', call: call };
        Object.defineProperty(window, 'FYBridge', {
            enumerable: true,
            value: FYBridge,
        });
    }
    return FYBridge.call.apply(FYBridge, __spread(args));
};
function LXCall(apiName, params, formatOptions, errFormatOptions) {
    if (formatOptions === void 0) { formatOptions = {}; }
    if (errFormatOptions === void 0) { errFormatOptions = {}; }
    apiCall(apiName, params, JSCall, formatOptions, errFormatOptions);
}
function showLoading$8(params) {
    LXCall('open_loading_view', params);
}
function choosePhoneContact$7(params) {
    var formatOutput = function (ret) {
        return {
            name: ret.name,
            phone: ret.phone,
        };
    };
    LXCall('select_contacts', params, { formatOutput: formatOutput });
}
function getDeviceId$4(params) {
    var outputMap = {
        deviceId: 'device_id',
    };
    LXCall('client_info', params, { outputMap: outputMap });
}
function getNetworkType$8(params) {
    var formatOutput = function (ret) {
        var type = "" + ret.state;
        switch (type) {
            case '2':
                type = 'WIFI';
                break;
            case '5':
                type = '4G';
                break;
            case '4':
                type = '3G';
                break;
            case '3':
                type = '2G';
                break;
            case '6':
                type = '5G';
                break;
            case '7':
                type = 'NONE';
                break;
            case '0':
            case '1':
            default:
                type = 'UNKNOWN';
                break;
        }
        return { networkType: type };
    };
    LXCall('networktype', params, { formatOutput: formatOutput });
}
function openInBrowser$1(params) {
    LXCall('open_system_browser', params);
}
function setNaviBarRightItem$5(params) {
    var formatInput = function (_a) {
        var type = _a.type, title = _a.title, iconBase64 = _a.iconBase64, onClick = _a.onClick;
        var options = __assign(__assign({}, params), { redDot: '-1', reset: false, override: false });
        if (type === 'text') {
            options.title = title;
            options.clickCallback = onClick;
        }
        if (type === 'icon') {
            options.title = 'ICON';
            options.img = iconBase64;
        }
        return options;
    };
    LXCall('set_webview_right_button', params, { formatInput: formatInput });
    JSCall('showOptionMenu');
}
function clearNaviBarRightItem$5(params) {
    return setNaviBarRightItem$5({
        title: ' ',
        iconBase64: '',
        onClick: function () { },
    });
}
function showSharePanel$d(params) {
    var formatInput = function (_a) {
        var image = _a.image, url = _a.url, title = _a.title, content = _a.content;
        return {
            data: {
                img_url: image,
                h5_url: url,
                title: title,
                content: content,
            },
        };
    };
    LXCall('share', params, { formatInput: formatInput });
}
function snapshot$1(params) {
    var formatInput = function () {
        var docElement = document.documentElement;
        return {
            origin_x: 0,
            origin_y: 0,
            width: docElement.offsetWidth,
            height: docElement.offsetHeight,
        };
    };
    LXCall('screenCapture_share', params, { formatInput: formatInput });
}
function vibrate$5(params) {
    LXCall('vibrate', params);
}
function alert$8(params) {
    var formatInput = function (_a) {
        var title = _a.title, content = _a.content, _b = _a.buttonText, buttonText = _b === void 0 ? '确定' : _b;
        return {
            title: title,
            message: content,
            buttonNames: [buttonText],
        };
    };
    LXCall('alert', params, { formatInput: formatInput });
}
function confirm$6(params) {
    var formatInput = function (_a) {
        var title = _a.title, content = _a.content, _b = _a.confirmButtonText, confirmButtonText = _b === void 0 ? '确定' : _b, _c = _a.cancelButtonText, cancelButtonText = _c === void 0 ? '取消' : _c;
        return {
            title: title,
            message: content,
            buttonNames: [cancelButtonText, confirmButtonText],
        };
    };
    var formatOutput = function (ret) {
        return {
            confirm: ret.button_index === 1,
        };
    };
    LXCall('confirm', params, { formatInput: formatInput, formatOutput: formatOutput });
}
function navigateTo$e(params) {
    var formatInput = function (_a) {
        var url = _a.url;
        return {
            pageName: 'webview',
            animeType: 2,
            data: {
                url: url,
            },
        };
    };
    LXCall('goto', params, { formatInput: formatInput });
}
function getLocation$8(params) {
    var formatOutput = function (ret) {
        return {
            longitude: ret.longitude,
            latitude: ret.latitude,
            country: ret.country,
            countryCode: ret.countryCode,
            province: ret.province,
            city: ret.city.replace(/市$/i, ''),
            cityAdCode: ret.citycode,
        };
    };
    var onFail = enhanceFail(params === null || params === void 0 ? void 0 : params.fail);
    var _success = enhanceSuccess(params === null || params === void 0 ? void 0 : params.success, params, { formatOutput: formatOutput });
    var onSuccess = function (ret) {
        try {
            _success(ret);
        }
        catch (e) {
            onFail(e);
        }
    };
    JSCall('native://lbs/locate', params, onSuccess, onFail);
}
function redirectTo$6(params) {
    var formatInput = function (_a) {
        var url = _a.url;
        return {
            pageName: 'webview',
            animeType: -1,
            data: {
                url: setSearch(url, { _fli_popBeforeOpen: true }),
            },
        };
    };
    LXCall('goto', params, { formatInput: formatInput });
}
function setNavigationBar$d(params) {
    var formatInput = function (_a) {
        var subtitle = _a.subtitle, image = _a.image;
        var options = {};
        if (subtitle) {
            options = __assign(__assign({}, options), { subtitle: subtitle });
        }
        options = __assign(__assign({}, options), { image: image });
        return options;
    };
    LXCall('set_webview_title', params, { formatInput: formatInput });
}
function showToast$7(params) {
    var formatInput = function (_a) {
        var content = _a.content, _b = _a.type, type = _b === void 0 ? 'none' : _b, _c = _a.duration, duration = _c === void 0 ? 1500 : _c;
        return {
            message: content,
            type: type,
            duration: duration,
        };
    };
    LXCall('toast', params, { formatInput: formatInput });
}
function scan$a(params) {
    var formatInput = function () {
        return {
            action: 'RETURN',
        };
    };
    LXCall('scan_code', params, { formatInput: formatInput });
}
function navigateBack$d(params) {
    methodChannel.call('close', params, function () { }, function () { });
}
function isAppInstalled$3(params) {
    var inputMap = {
        package_name: 'android',
        scheme: 'ios',
    };
    LXCall('is_installed_app', params, { inputMap: inputMap });
}
function hideTitle$5(params) {
    var formatInput = function () {
        return {
            titlebarDisplay: 'hide',
        };
    };
    LXCall('set_ui', params, { formatInput: formatInput });
}
function showTitle$3(params) {
    var formatInput = function () {
        return {
            titlebarDisplay: 'show',
        };
    };
    LXCall('set_ui', params, { formatInput: formatInput });
}
function saveImage$4(params) {
    LXCall('save_image_to_album', params, {});
}
function chooseImage$6(params) {
    var formatInput = function (options) {
        return {
            pickType: 0,
            maxSelect: options.count || 1,
        };
    };
    LXCall('take_photo', params, { formatInput: formatInput });
}
function getStatusBarHeight$3(params) {
    var success = enhanceSuccess(params.success, params);
    success === null || success === void 0 ? void 0 : success({
        statusBarHeight: isIOS
            ? isIphoneXSeries
                ? 88
                : 40
            : window.__STATUS_BAR_HEIGHT__,
    });
}

function getScriptFromCDN(url, retryTimes, maxRetryTimes, resolveCB, rejectCB) {
    var doc = document;
    var head = doc.head || doc.getElementsByTagName('head')[0] || doc.documentElement;
    var node = doc.createElement('script');
    node.setAttribute('charset', 'utf-8');
    if ('onload' in node) {
        node.onload = function () {
            resolveCB && resolveCB();
        };
        node.onerror = function (e) {
            if (retryTimes < maxRetryTimes) {
                retryTimes++;
                getScriptFromCDN(url, retryTimes, maxRetryTimes, resolveCB, rejectCB);
            }
            else {
                rejectCB && rejectCB();
            }
        };
    }
    else {
        node.onreadystatechange = function () {
            if (/loaded|complete/.test(node.readyState)) {
                resolveCB && resolveCB();
            }
        };
    }
    node.async = true;
    node.src = url;
    head.appendChild(node);
}
function loadScripts(libs, maxRetryTimes) {
    var promiseList = [];
    var _loop_1 = function (i) {
        var promise = new Promise(function (resolve, reject) {
            getScriptFromCDN(libs[i], 0, maxRetryTimes, resolve, reject);
        });
        promiseList.push(promise);
    };
    for (var i = 0; i < libs.length; i++) {
        _loop_1(i);
    }
    return Promise.all(promiseList);
}

var MAX_CDN_RESOURCE_RETRY_TIMES = 1;

function DDCall$1(api, params, formatOptions, errFormatOptions) {
    if (formatOptions === void 0) { formatOptions = {}; }
    if (errFormatOptions === void 0) { errFormatOptions = {}; }
    apiCall(null, params, api, formatOptions, errFormatOptions);
}
function showToast$6(params) {
    var api = dd.device.notification.toast;
    var formatInput = function (input) {
        return {
            icon: '',
            text: input.content,
            duration: input.duration
                ? input.duration > 100
                    ? input.duration / 1000
                    : input.duration
                : 2,
            delay: 0,
        };
    };
    return DDCall$1(api, params, { formatInput: formatInput });
}
function alert$7(params) {
    var api = dd.device.notification.alert;
    var inputMap = {
        title: 'title',
        message: 'content',
        buttonName: 'buttonText',
    };
    return DDCall$1(api, params, { inputMap: inputMap });
}
function confirm$5(params) {
    var api = dd.device.notification.confirm;
    var formatOutput = function (ret) {
        return {
            confirm: ret.buttonIndex === 0,
        };
    };
    var formatInput = function (input) {
        return {
            message: input.content,
            buttonLabels: [input.confirmButtonText, input.cancelButtonText],
        };
    };
    return DDCall$1(api, params, { formatInput: formatInput, formatOutput: formatOutput });
}
function showActionSheet$7(params) {
    var api = dd.device.notification.actionSheet;
    var outputMap = {
        index: 'buttonIndex',
    };
    var formatInput = function (input) {
        return {
            cancelButton: input.cancelButtonText || '取消',
            otherButtons: input.items,
        };
    };
    return DDCall$1(api, params, { outputMap: outputMap, formatInput: formatInput });
}
function showLoading$7(params) {
    var api = dd.device.notification.showPreloader;
    var formatInput = function () {
        return { text: '', showIcon: true };
    };
    return DDCall$1(api, params, { formatInput: formatInput });
}
function hideLoading$7(params) {
    var api = dd.device.notification.hidePreloader;
    return DDCall$1(api, params);
}
function setNavigationBar$c(params) {
    var api = dd.biz.navigation.setTitle;
    return DDCall$1(api, params);
}
function setNaviBarRightItem$4(params) {
    if (params.type === 'text') {
        var api = dd.biz.navigation.setRight;
        var formatInput = function (input) {
            return {
                show: true,
                control: true,
                text: input.title,
                onSuccess: function (e) {
                    var onClick = (params === null || params === void 0 ? void 0 : params.onClick) || function () { };
                    onClick(e);
                },
            };
        };
        DDCall$1(api, params, { formatInput: formatInput });
    }
    else {
        var onFail = enhanceFail(params.fail);
        return onFail({ error: '1', errMsg: 'not support options icon' });
    }
}
function clearNaviBarRightItem$4(params) {
    return new Promise(function (resolve, reject) {
        var api = dd.biz.navigation.setRight;
        var formatInput = function (input) {
            return {
                control: false,
                text: '分享',
            };
        };
        return DDCall$1(api, params, { formatInput: formatInput });
    });
}
function choosePhoneContact$6(params) {
    var api = dd.biz.contact.chooseMobileContacts;
    var formatOutput = function (ret) {
        return {
            name: ret[0].name,
            phone: ret[0].mobile.replace(/(\s|-)+/g, ''),
            multiple: false,
        };
    };
    return DDCall$1(api, params, { formatOutput: formatOutput });
}
function showSharePanel$c(params) {
    var api = dd.biz.util.share;
    var formatInput = function (input) {
        return {
            type: 0,
            url: input.url,
            title: input.title,
            content: input.content,
            image: input.image,
        };
    };
    return DDCall$1(api, params, { formatInput: formatInput });
}
function navigateTo$d(params) {
    var api = dd.biz.util.openLink;
    return DDCall$1(api, params);
}
function navigateBack$c(params) {
    var api = dd.biz.navigation.close;
    return DDCall$1(api, params);
}
function previewImage$8(params) {
    var formatInput = function (options) {
        var _a, _b;
        var current = (_a = options === null || options === void 0 ? void 0 : options.urls) === null || _a === void 0 ? void 0 : _a[0];
        if (options.current !== undefined) {
            current = (_b = options === null || options === void 0 ? void 0 : options.urls) === null || _b === void 0 ? void 0 : _b[+options.current];
        }
        return { current: current };
    };
    if (typeof dd === 'undefined') {
        var urls = [
            'https://g.alicdn.com/dingding/dingtalk-jsapi/2.10.3/dingtalk.open.js',
        ];
        loadScripts(urls, MAX_CDN_RESOURCE_RETRY_TIMES).then(function () {
            var api = dd.biz.util.previewImage;
            return DDCall$1(api, params, { formatInput: formatInput });
        });
    }
    else {
        var api = dd.biz.util.previewImage;
        return DDCall$1(api, params, { formatInput: formatInput });
    }
}
function getNetworkType$7(params) {
    var api = dd.device.connection.getNetworkType;
    var formatOutput = function (ret) {
        return {
            networkType: (ret.result || '').toUpperCase(),
        };
    };
    return DDCall$1(api, params, { formatOutput: formatOutput });
}
function getLocation$7(params) {
    var formatOutput = function (ret) {
        return {
            longitude: ret.longitude.toString(),
            latitude: ret.latitude.toString(),
        };
    };
    var formatInput = function (input) {
        var targetAccuracy = input.highAccuracy ? 50 : 200;
        return {
            targetAccuracy: targetAccuracy,
            coordinate: 0,
            withReGeocode: false,
            useCache: true,
        };
    };
    return DDCall$1(dd.device.geolocation.get, params, {
        formatInput: formatInput,
        formatOutput: formatOutput,
    });
}
function isAppInstalled$2(params) {
    var api = dd.device.launcher.checkInstalledApps;
    var formatInput = function (input) {
        return { apps: [input.ios, input.ios] };
    };
    var formatOutput = function (ret) {
        return {
            installed: ret.installed.some(function (schema) {
                return params.ios === schema || params.android === schema;
            }),
        };
    };
    return DDCall$1(api, params, { formatInput: formatInput, formatOutput: formatOutput });
}
function setClipboard$7(params) {
    var api = dd.biz.clipboardData.setData;
    return DDCall$1(api, params);
}
function scan$9(params) {
    var api = dd.biz.util.scan;
    var type = 'all';
    var resultType = 'QR';
    if (params.type === 'qr') {
        type = 'qrCode';
        resultType = 'QR';
    }
    if (params.type === 'bar') {
        type = 'barCode';
        resultType = 'BAR';
    }
    var formatOutput = function (ret) {
        return {
            type: resultType,
            code: ret.text,
        };
    };
    var formatInput = function () {
        return { type: type };
    };
    return DDCall$1(api, params, { formatInput: formatInput, formatOutput: formatOutput });
}
function vibrate$4(params) {
    var api = dd.device.notification.vibrate;
    var formatInput = function () {
        return { duration: 300 };
    };
    DDCall$1(api, params, { formatInput: formatInput });
}

function DDCall(api, params, formatOptions, errFormatOptions) {
    if (formatOptions === void 0) { formatOptions = {}; }
    if (errFormatOptions === void 0) { errFormatOptions = {}; }
    apiCall(null, params, api, formatOptions, errFormatOptions);
}
function showToast$5(params) {
    var api = dd.device.notification.toast;
    var formatInput = function (input) {
        return {
            icon: '',
            text: input.content,
            duration: input.duration
                ? input.duration > 100
                    ? input.duration / 1000
                    : input.duration
                : 2,
            delay: 0,
        };
    };
    return DDCall(api, params, { formatInput: formatInput });
}
function alert$6(params) {
    var api = dd.device.notification.alert;
    var inputMap = {
        title: 'title',
        message: 'content',
        buttonName: 'buttonText',
    };
    return DDCall(api, params, { inputMap: inputMap });
}
function confirm$4(params) {
    var api = dd.device.notification.confirm;
    var formatOutput = function (ret) {
        return {
            confirm: ret.buttonIndex === 0,
        };
    };
    var formatInput = function (input) {
        return {
            message: input.content,
            buttonLabels: [input.confirmButtonText, input.cancelButtonText],
        };
    };
    return DDCall(api, params, { formatInput: formatInput, formatOutput: formatOutput });
}
function showActionSheet$6(params) {
    var api = dd.device.notification.actionSheet;
    var outputMap = {
        index: 'buttonIndex',
    };
    var formatInput = function (input) {
        return {
            cancelButton: input.cancelButtonText || '取消',
            otherButtons: input.items,
        };
    };
    return DDCall(api, params, { outputMap: outputMap, formatInput: formatInput });
}
function showLoading$6(params) {
    var api = dd.device.notification.showPreloader;
    var formatInput = function () {
        return { text: '', showIcon: true };
    };
    return DDCall(api, params, { formatInput: formatInput });
}
function hideLoading$6(params) {
    var api = dd.device.notification.hidePreloader;
    return DDCall(api, params);
}
function setNavigationBar$b(params) {
    var api = dd.biz.navigation.setTitle;
    return DDCall(api, params);
}
function setNaviBarRightItem$3(params) {
    if (params.type === 'text') {
        var api = dd.biz.navigation.setRight;
        var formatInput = function (input) {
            return {
                show: true,
                control: true,
                text: input.title,
                onSuccess: function (e) {
                    var onClick = (params === null || params === void 0 ? void 0 : params.onClick) || function () { };
                    onClick(e);
                },
            };
        };
        DDCall(api, params, { formatInput: formatInput });
    }
    else {
        var onFail = enhanceFail(params.fail);
        return onFail({ error: '1', errMsg: 'not support options icon' });
    }
}
function clearNaviBarRightItem$3(params) {
    return new Promise(function (resolve, reject) {
        var api = dd.biz.navigation.setRight;
        var formatInput = function (input) {
            return {
                control: false,
                text: '分享',
            };
        };
        return DDCall(api, params, { formatInput: formatInput });
    });
}
function choosePhoneContact$5(params) {
    var api = dd.biz.contact.chooseMobileContacts;
    var formatOutput = function (ret) {
        return {
            name: ret[0].name,
            phone: ret[0].mobile.replace(/(\s|-)+/g, ''),
            multiple: false,
        };
    };
    return DDCall(api, params, { formatOutput: formatOutput });
}
function showSharePanel$b(params) {
    var api = dd.biz.util.share;
    var formatInput = function (input) {
        return {
            type: 0,
            url: input.url,
            title: input.title,
            content: input.content,
            image: input.image,
        };
    };
    return DDCall(api, params, { formatInput: formatInput });
}
function navigateTo$c(params) {
    var api = dd.biz.util.openLink;
    return DDCall(api, params);
}
function previewImage$7(params) {
    var formatInput = function (options) {
        var _a, _b;
        var current = (_a = options === null || options === void 0 ? void 0 : options.urls) === null || _a === void 0 ? void 0 : _a[0];
        if (options.current !== undefined) {
            current = (_b = options === null || options === void 0 ? void 0 : options.urls) === null || _b === void 0 ? void 0 : _b[+options.current];
        }
        return { current: current };
    };
    if (typeof dd === 'undefined') {
        var urls = [
            'https://g.alicdn.com/dingding/dingtalk-jsapi/2.10.3/dingtalk.open.js',
        ];
        loadScripts(urls, MAX_CDN_RESOURCE_RETRY_TIMES).then(function () {
            var api = dd.biz.util.previewImage;
            return DDCall(api, params, { formatInput: formatInput });
        });
    }
    else {
        var api = dd.biz.util.previewImage;
        return DDCall(api, params, { formatInput: formatInput });
    }
}
function getNetworkType$6(params) {
    var api = dd.device.connection.getNetworkType;
    var formatOutput = function (ret) {
        return {
            networkType: (ret.result || '').toUpperCase(),
        };
    };
    return DDCall(api, params, { formatOutput: formatOutput });
}
function getLocation$6(params) {
    var formatOutput = function (ret) {
        return {
            longitude: ret.longitude.toString(),
            latitude: ret.latitude.toString(),
        };
    };
    var formatInput = function (input) {
        var targetAccuracy = input.highAccuracy ? 50 : 200;
        return {
            targetAccuracy: targetAccuracy,
            coordinate: 0,
            withReGeocode: false,
            useCache: true,
        };
    };
    return DDCall(dd.device.geolocation.get, params, {
        formatInput: formatInput,
        formatOutput: formatOutput,
    });
}
function isAppInstalled$1(params) {
    var api = dd.device.launcher.checkInstalledApps;
    var formatInput = function (input) {
        return { apps: [input.ios, input.ios] };
    };
    var formatOutput = function (ret) {
        return {
            installed: ret.installed.some(function (schema) {
                return params.ios === schema || params.android === schema;
            }),
        };
    };
    return DDCall(api, params, { formatInput: formatInput, formatOutput: formatOutput });
}
function setClipboard$6(params) {
    var api = dd.biz.clipboardData.setData;
    return DDCall(api, params);
}
function scan$8(params) {
    var api = dd.biz.util.scan;
    var type = 'all';
    var resultType = 'QR';
    if (params.type === 'qr') {
        type = 'qrCode';
        resultType = 'QR';
    }
    if (params.type === 'bar') {
        type = 'barCode';
        resultType = 'BAR';
    }
    var formatOutput = function (ret) {
        return {
            type: resultType,
            code: ret.text,
        };
    };
    var formatInput = function () {
        return { type: type };
    };
    return DDCall(api, params, { formatInput: formatInput, formatOutput: formatOutput });
}
function vibrate$3(params) {
    var api = dd.device.notification.vibrate;
    var formatInput = function () {
        return { duration: 300 };
    };
    DDCall(api, params, { formatInput: formatInput });
}

function navigateBack$b(params) {
    var api = dd.biz.navigation.close(params);
    DDCall(api, params);
}

function alert$5() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return my.alert.apply(my, __spread(args));
}
function chooseCity$3() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return my.chooseCity.apply(my, __spread(args));
}
function chooseImage$5() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    if (args[0] && typeof args[0] === 'object') {
        return my.chooseImage.apply(my, __spread([
            __assign(__assign({}, args[0]), { fail: function (err) {
                    var _a, _b, _c;
                    var systemInfo = (_a = my === null || my === void 0 ? void 0 : my.getSystemInfoSync) === null || _a === void 0 ? void 0 : _a.call(my);
                    if ((systemInfo === null || systemInfo === void 0 ? void 0 : systemInfo.app) === 'TB' && (systemInfo === null || systemInfo === void 0 ? void 0 : systemInfo.platform) === 'iOS') {
                        if (err.error === 1) {
                            alert$5({
                                title: '开启相册权限',
                                content: '开启后才能访问你的照片',
                                buttonText: '我知道了',
                            });
                        }
                    }
                    (_c = (_b = args[0]) === null || _b === void 0 ? void 0 : _b.fail) === null || _c === void 0 ? void 0 : _c.call(_b, err);
                }, success: function (res) {
                    var _a, _b;
                    var formattedRes = {
                        dataList: res === null || res === void 0 ? void 0 : res.apFilePaths.map(function (path, i) {
                            return {
                                previewURL: path,
                                fileURL: res === null || res === void 0 ? void 0 : res.tempFiles[i],
                            };
                        }),
                        _orignal: {
                            input: args[0],
                            output: res,
                        },
                    } || [];
                    (_b = (_a = args[0]) === null || _a === void 0 ? void 0 : _a.success) === null || _b === void 0 ? void 0 : _b.call(_a, formattedRes);
                } })
        ], args.slice(1)));
    }
    return my.chooseImage.apply(my, __spread(args));
}
function choosePhoneContact$4() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return my.choosePhoneContact.apply(my, __spread(args));
}
function confirm$3() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return my.confirm.apply(my, __spread(args));
}
function getLocation$5() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return my.getLocation.apply(my, __spread(args));
}
function getNetworkType$5() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return my.getNetworkType.apply(my, __spread(args));
}
function hideLoading$5() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return my.hideLoading.apply(my, __spread(args));
}
function hideNavigationBarLoading$2() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return my.hideNavigationBarLoading.apply(my, __spread(args));
}
function hideToast$4() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return my.hideToast.apply(my, __spread(args));
}
function navigateBack$a() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return my.navigateBack.apply(my, __spread(args));
}
function navigateTo$b() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return my.navigateTo.apply(my, __spread(args));
}
function previewImage$6() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return my.previewImage.apply(my, __spread(args));
}
function redirectTo$5() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return my.redirectTo.apply(my, __spread(args));
}
function saveImage$3(params) {
    return my.saveImage(params);
}
function scan$7() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return my.scan.apply(my, __spread(args));
}
function setBackgroundColor$4() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return my.setBackgroundColor.apply(my, __spread(args));
}
function setClipboard$5() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return my.setClipboard.apply(my, __spread(args));
}
function setNavigationBar$a() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return my.setNavigationBar.apply(my, __spread(args));
}
function showActionSheet$5() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return my.showActionSheet.apply(my, __spread(args));
}
function showLoading$5() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return my.showLoading.apply(my, __spread(args));
}
function showNavigationBarLoading$2() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return my.showNavigationBarLoading.apply(my, __spread(args));
}
function showSharePanel$a() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return my.showSharePanel.apply(my, __spread(args));
}
function showToast$4() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return my.showToast.apply(my, __spread(args));
}
function vibrate$2() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return my.vibrate.apply(my, __spread(args));
}
function vibrateLong$4() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return my.vibrateLong.apply(my, __spread(args));
}
function vibrateShort$4() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return my.vibrateShort.apply(my, __spread(args));
}
function getStorage$4() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return my.getStorage.apply(my, __spread(args));
}
function getStorageSync$5() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return my.getStorageSync.apply(my, __spread(args));
}
function setStorage$4() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return my.setStorage.apply(my, __spread(args));
}
function setStorageSync$5() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return my.setStorageSync.apply(my, __spread(args));
}
function removeStorage$4() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return my.removeStorage.apply(my, __spread(args));
}
function removeStorageSync$5() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return my.removeStorageSync.apply(my, __spread(args));
}
function clearStorage$3() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return my.clearStorage.apply(my, __spread(args));
}
function clearStorageSync$4() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return my.clearStorageSync.apply(my, __spread(args));
}
function optionsSelect() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return my.optionsSelect.apply(my, __spread(args));
}
function datePicker$1() {
    var _a, _b, _c, _d;
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var systemInfo = (_a = my === null || my === void 0 ? void 0 : my.getSystemInfoSync) === null || _a === void 0 ? void 0 : _a.call(my);
    if (args[0] &&
        typeof args[0] === 'object' &&
        args[0].format === 'yyyy' &&
        (systemInfo === null || systemInfo === void 0 ? void 0 : systemInfo.app) === 'TB' &&
        (systemInfo === null || systemInfo === void 0 ? void 0 : systemInfo.platform) === 'Android') {
        var fullYear = new Date().getFullYear();
        var yearNameList = [];
        var yearList_1 = [];
        var startYear = parseInt((_b = args[0]) === null || _b === void 0 ? void 0 : _b.startDate) || fullYear;
        var endYear = parseInt((_c = args[0]) === null || _c === void 0 ? void 0 : _c.endDate) || fullYear;
        var selectedOneIndex = 0;
        for (var year = startYear; year <= endYear; year++) {
            if (year === parseInt((_d = args[0]) === null || _d === void 0 ? void 0 : _d.currentDate)) {
                selectedOneIndex = yearList_1.length;
            }
            yearNameList.push(year + " \u5E74");
            yearList_1.push(year);
        }
        return optionsSelect({
            title: '',
            optionsOne: yearNameList,
            selectedOneIndex: selectedOneIndex,
            success: function (res) { var _a, _b; return (_b = (_a = args[0]) === null || _a === void 0 ? void 0 : _a.success) === null || _b === void 0 ? void 0 : _b.call(_a, {
                date: yearList_1[res === null || res === void 0 ? void 0 : res.selectedOneIndex],
            }); },
        });
    }
    return my.datePicker.apply(my, __spread(args));
}

function genParams(params, formatOptions) {
    var _a;
    if (formatOptions === void 0) { formatOptions = {}; }
    var success = params.success, fail = params.fail;
    var options = {};
    var formatInput = formatOptions.formatInput, inputMap = formatOptions.inputMap, formatOutput = formatOptions.formatOutput, outputMap = formatOptions.outputMap;
    if (typeof formatInput === 'function') {
        options = formatInput(params);
    }
    else if (inputMap) {
        (_a = Object.keys(inputMap)) === null || _a === void 0 ? void 0 : _a.forEach(function (key) {
            options[key] = params[inputMap[key]];
        });
    }
    var _success = enhanceSuccess(success, options, {
        outputMap: outputMap,
        formatOutput: formatOutput,
    });
    var _fail = enhanceFail(fail);
    return __assign(__assign(__assign({}, params), options), { success: _success, fail: _fail });
}

function alert$4(params) {
    var formatInput = function (options) {
        return {
            confirmText: options.buttonText || '',
            showCancel: false,
        };
    };
    var options = genParams(params, { formatInput: formatInput });
    wx.showModal(options);
}
function setNavigationBar$9(params) {
    var backgroundColor = params.backgroundColor, title = params.title;
    var options = genParams(params);
    if (backgroundColor) {
        wx.setNavigationBarColor(options);
    }
    if (title) {
        wx.setNavigationBarTitle(options);
    }
}
function hideToast$3(params) {
    var options = genParams(params);
    wx.hideToast(options);
}
function showActionSheet$4(params) {
    var inputMap = {
        alerText: 'hideTitle',
        itemList: 'items',
    };
    var options = genParams(params, { inputMap: inputMap });
    return wx.showActionSheet(options);
}
function choosePhoneContact$3(params) {
    var outputMap = {
        phoneNumber: 'mobile',
        displayName: 'name',
    };
    var options = genParams(params, { outputMap: outputMap });
    return wx.chooseContact(options);
}
function navigateBack$9(params) {
    var options = genParams(params);
    return wx.navigateBack(options);
}
function showLoading$4(params) {
    var inputMap = {
        title: 'content',
    };
    var options = genParams(params, { inputMap: inputMap });
    return wx.showLoading(options);
}
function navigateTo$a(params) {
    var options = genParams(params);
    wx.navigateTo(options);
}
function showToast$3(params) {
    var formatInput = function (options) {
        return {
            title: 'content',
            icon: options.type === 'fail' ? 'error' : options.type,
        };
    };
    var options = genParams(params, { formatInput: formatInput });
    return wx.showToast(options);
}
function previewImage$5(params) {
    var options = genParams(params);
    return wx.previewImage(options);
}
function redirectTo$4(params) {
    var options = genParams(params);
    return wx.redirectTo(options);
}
function showSharePanel$9(params) {
    var options = genParams(params);
    return wx.showShareMenu(options);
}
function chooseImage$4(params) {
    var options = genParams(params);
    return wx.chooseImage(options);
}
function getLocation$4(params) {
    var options = genParams(params);
    return wx.getLocation(options);
}
function scan$6(params) {
    var options = genParams(params);
    return wx.scanCode(options);
}
function vibrateLong$3(params) {
    var options = genParams(params);
    return wx.vibrateLong(options);
}
function getNetworkType$4(params) {
    var options = genParams(params);
    return wx.getNetworkType(options);
}
function setBackgroundColor$3(params) {
    var options = genParams(params);
    return wx.setBackgroundColor(options);
}
function vibrateShort$3(params) {
    var options = genParams(params);
    return wx.vibrateShort(options);
}
function getOrientation$2(params) {
    var options = genParams(params);
    return wx.getOrientation(options);
}
function setClipboard$4(params) {
    var inputMap = {
        data: 'text',
    };
    var options = genParams(params, { inputMap: inputMap });
    return wx.setClipboardData(options);
}
function hideLoading$4(params) {
    var options = genParams(params);
    return wx.hideLoading(options);
}
function getStorage$3() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return wx.getStorage.apply(wx, __spread(args));
}
function setStorage$3() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return wx.setStorage.apply(wx, __spread(args));
}
function removeStorage$3() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return wx.removeStorage.apply(wx, __spread(args));
}
function clearStorage$2() {
    return wx.clearStorage();
}
function getStorageSync$4(params) {
    var key = params.key;
    var data = params.data;
    return wx.getStorageSync(key, data);
}
function setStorageSync$4(params) {
    var key = params.key;
    var data = params.data;
    return wx.setStorageSync(key, data);
}
function removeStorageSync$4(params) {
    var key = params.key;
    return wx.removeStorageSync(key);
}
function clearStorageSync$3() {
    return wx.clearStorageSync();
}
function saveImage$2(params) {
    genParams(params, {
        inputMap: {
            filePath: 'url',
        },
    });
    wx.saveImageToPhotosAlbum(params);
}

function alert$3(params) {
    var formatInput = function (options) {
        return {
            confirmText: options.buttonText || '',
            showCancel: false,
        };
    };
    var options = genParams(params, { formatInput: formatInput });
    tt.showModal(options);
}
function setNavigationBar$8(params) {
    var backgroundColor = params.backgroundColor, title = params.title;
    var options = genParams(params);
    if (backgroundColor) {
        tt.setNavigationBarColor(options);
    }
    if (title) {
        tt.setNavigationBarTitle(options);
    }
}
function hideToast$2(params) {
    var options = genParams(params);
    tt.hideToast(options);
}
function showActionSheet$3(params) {
    var inputMap = {
        alerText: 'hideTitle',
        itemList: 'items',
    };
    var options = genParams(params, { inputMap: inputMap });
    return tt.showActionSheet(options);
}
function choosePhoneContact$2(params) {
    var outputMap = {
        phoneNumber: 'mobile',
        displayName: 'name',
    };
    var options = genParams(params, { outputMap: outputMap });
    return tt.chooseContact(options);
}
function navigateBack$8(params) {
    var options = genParams(params);
    return tt.navigateBack(options);
}
function showLoading$3(params) {
    var inputMap = {
        title: 'content',
    };
    var options = genParams(params, { inputMap: inputMap });
    return tt.showLoading(options);
}
function navigateTo$9(params) {
    var options = genParams(params);
    tt.navigateTo(options);
}
function showToast$2(params) {
    var formatInput = function (options) {
        return {
            title: 'content',
            icon: options.type === 'fail' ? 'error' : options.type,
        };
    };
    var options = genParams(params, { formatInput: formatInput });
    return tt.showToast(options);
}
function previewImage$4(params) {
    var options = genParams(params);
    return tt.previewImage(options);
}
function redirectTo$3(params) {
    var options = genParams(params);
    return tt.redirectTo(options);
}
function showSharePanel$8(params) {
    var options = genParams(params);
    return tt.showShareMenu(options);
}
function chooseImage$3(params) {
    var options = genParams(params);
    return tt.chooseImage(options);
}
function getLocation$3(params) {
    var options = genParams(params);
    return tt.getLocation(options);
}
function scan$5(params) {
    var options = genParams(params);
    return tt.scanCode(options);
}
function vibrateLong$2(params) {
    var options = genParams(params);
    return tt.vibrateLong(options);
}
function getNetworkType$3(params) {
    var options = genParams(params);
    return tt.getNetworkType(options);
}
function setBackgroundColor$2(params) {
    var options = genParams(params);
    return tt.setBackgroundColor(options);
}
function vibrateShort$2(params) {
    var options = genParams(params);
    return tt.vibrateShort(options);
}
function getOrientation$1(params) {
    var options = genParams(params);
    return tt.getOrientation(options);
}
function setClipboard$3(params) {
    var inputMap = {
        data: 'text',
    };
    var options = genParams(params, { inputMap: inputMap });
    return tt.setClipboardData(options);
}
function hideLoading$3(params) {
    var options = genParams(params);
    return tt.hideLoading(options);
}
function getStorage$2() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return tt.getStorage.apply(tt, __spread(args));
}
function setStorage$2() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return tt.setStorage.apply(tt, __spread(args));
}
function removeStorage$2() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return tt.removeStorage.apply(tt, __spread(args));
}
function clearStorage$1() {
    return tt.clearStorage();
}
function getStorageSync$3(params) {
    var key = params.key;
    var data = params.data;
    return tt.getStorageSync(key, data);
}
function setStorageSync$3(params) {
    var key = params.key;
    var data = params.data;
    return tt.setStorageSync(key, data);
}
function removeStorageSync$3(params) {
    var key = params.key;
    return tt.removeStorageSync(key);
}
function clearStorageSync$2() {
    return tt.clearStorageSync();
}
function saveImage$1(params) {
    genParams(params, {
        inputMap: {
            filePath: 'url',
        },
    });
    tt.saveImageToPhotosAlbum(params);
}

function alert$2() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return my.alert.apply(my, __spread(args));
}
function chooseCity$2() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return my.chooseCity.apply(my, __spread(args));
}
function chooseImage$2() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return my.chooseImage.apply(my, __spread(args));
}
function choosePhoneContact$1() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return my.choosePhoneContact.apply(my, __spread(args));
}
function confirm$2() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return my.confirm.apply(my, __spread(args));
}
function getLocation$2() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return my.getLocation.apply(my, __spread(args));
}
function getNetworkType$2() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return my.getNetworkType.apply(my, __spread(args));
}
function hideLoading$2() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return my.hideLoading.apply(my, __spread(args));
}
function hideNavigationBarLoading$1() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return my.hideNavigationBarLoading.apply(my, __spread(args));
}
function hideToast$1() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return my.hideToast.apply(my, __spread(args));
}
function navigateBack$7() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return my.navigateBack.apply(my, __spread(args));
}
function navigateTo$8() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return my.navigateTo.apply(my, __spread(args));
}
function previewImage$3() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return my.previewImage.apply(my, __spread(args));
}
function redirectTo$2() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return my.redirectTo.apply(my, __spread(args));
}
function scan$4() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return my.scan.apply(my, __spread(args));
}
function setBackgroundColor$1() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return my.setBackgroundColor.apply(my, __spread(args));
}
function setClipboard$2() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return my.setClipboard.apply(my, __spread(args));
}
function setNavigationBar$7() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return my.setNavigationBar.apply(my, __spread(args));
}
function showActionSheet$2() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return my.showActionSheet.apply(my, __spread(args));
}
function showLoading$2() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return my.showLoading.apply(my, __spread(args));
}
function showNavigationBarLoading$1() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return my.showNavigationBarLoading.apply(my, __spread(args));
}
function showSharePanel$7() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return my.showSharePanel.apply(my, __spread(args));
}
function showToast$1() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return my.showToast.apply(my, __spread(args));
}
function vibrate$1() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return my.vibrate.apply(my, __spread(args));
}
function vibrateLong$1() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return my.vibrateLong.apply(my, __spread(args));
}
function vibrateShort$1() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return my.vibrateShort.apply(my, __spread(args));
}
function uploadImage$1() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return my.uploadFile.apply(my, __spread(args));
}

var setBackgroundColor;
if (isWeb) {
    if (isWindvane) {
        setBackgroundColor = setBackgroundColor$5;
    }
    else if (isNebula) {
        setBackgroundColor = notSupport;
    }
    else if (isFliggy) {
        setBackgroundColor = notSupport;
    }
    else if (isDingTalk) {
        setBackgroundColor = notSupport;
    }
    else if (isDingTalkPC) {
        setBackgroundColor = notSupport;
    }
}
else if (isMini) {
    if (isMiniAli) {
        setBackgroundColor = setBackgroundColor$4;
    }
    else if (isMiniWx) {
        setBackgroundColor = setBackgroundColor$3;
    }
    else if (isMiniTt) {
        setBackgroundColor = setBackgroundColor$2;
    }
}
else if (isMiniweb) {
    setBackgroundColor = setBackgroundColor$1;
}
if (!setBackgroundColor) {
    setBackgroundColor = notSupport;
}
var index$M = promisifyApi(setBackgroundColor);

var queue = [];
var isProcessing = false;
var toastWin;
var toastContent;
var toastIcon;
var styles$2 = {
    container: {
        backgroundColor: 'rgba(0, 0, 0, 0.6)',
        boxSizing: 'border-box',
        maxWidth: '80%',
        color: '#ffffff',
        padding: '8px 16px',
        position: 'fixed',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        left: '50%',
        bottom: '50%',
        fontSize: '16px',
        lineHeight: '32px',
        fontWeight: '600',
        borderRadius: '4px',
        textAlign: 'center',
        transition: 'all 0.4s ease-in-out',
        webkitTransition: 'all 0.4s ease-in-out',
        transform: 'translateX(-50%)',
        webkitTransform: 'translateX(-50%)',
        zIndex: 9999,
    },
    icon: {
        marginBottom: '5px',
        width: '45px',
        height: '45px',
    },
};
function showToastWindow(message, iconUrl) {
    if (!toastWin) {
        toastIcon = null;
        toastWin = document.createElement('div');
        toastWin.setAttribute('role', 'alert');
        toastWin.setAttribute('tabindex', '-1');
        for (var key in styles$2.container) {
            toastWin.style[key] = styles$2.container[key];
        }
        toastContent = document.createElement('div');
        toastWin.appendChild(toastContent);
        document.body.appendChild(toastWin);
    }
    if (toastIcon && !iconUrl) {
        toastWin.removeChild(toastIcon);
        toastIcon = null;
    }
    else if (toastIcon && iconUrl) {
        toastIcon.setAttribute('src', iconUrl);
    }
    else if (!toastIcon && iconUrl) {
        toastIcon = document.createElement('img');
        toastIcon.setAttribute('src', iconUrl);
        for (var key in styles$2.icon) {
            toastIcon.style[key] = styles$2.icon[key];
        }
        toastWin.insertBefore(toastIcon, toastContent);
    }
    toastContent.textContent = message;
    toastWin.style.transform = 'translateX(-50%)';
    toastWin.style.webkitTransform = 'translateX(-50%)';
}
function hideToastWindow() {
    setTimeout(function () {
        if (toastWin && toastWin.style) {
            toastWin.style.transform = 'translateX(-50%) scale(0.8)';
            toastWin.style.webkitTransform = 'translateX(-50%) scale(0.8)';
        }
    }, 0);
}
var initHideTimer = null;
var innerToast = {
    hideTimer: initHideTimer,
    show: function () {
        if (!queue.length) {
            if (toastWin) {
                toastWin.parentNode.removeChild(toastWin);
            }
            toastWin = null;
            return;
        }
        if (isProcessing)
            return;
        isProcessing = true;
        var toastInfo = queue.shift();
        try {
            showToastWindow(toastInfo.content, toastInfo.icon);
        }
        catch (e) {
            toastInfo.fail && toastInfo.fail(e);
            toastInfo.complete && toastInfo.complete(e);
        }
        innerToast.hideTimer = setTimeout(function () {
            toastInfo.success && toastInfo.success();
            toastInfo.complete && toastInfo.complete();
            innerToast.switchToNext();
        }, toastInfo.duration);
    },
    push: function (options) {
        queue.push(options);
        innerToast.show();
    },
    switchToNext: function () {
        hideToastWindow();
        isProcessing = false;
        setTimeout(function () { return innerToast.show(); }, 500);
        if (innerToast.hideTimer) {
            clearTimeout(innerToast.hideTimer);
            innerToast.hideTimer = null;
        }
    },
};
var show = function (options) {
    var _a = options.type, type = _a === void 0 ? 'none' : _a, content = options.content, duration = options.duration, success = options.success, fail = options.fail, complete = options.complete;
    var iconMap = {
        success: 'https://gw.alicdn.com/imgextra/i1/O1CN01h684sE1Td4mwYyChK_!!6000000002404-2-tps-200-200.png',
        fail: 'https://gw.alicdn.com/imgextra/i1/O1CN01yOywus1et4ORJzafk_!!6000000003928-2-tps-200-200.png',
        none: '',
    };
    innerToast.push({
        content: content,
        duration: duration,
        icon: iconMap[type] || '',
        success: function () {
            success && success();
        },
        fail: function (res) {
            fail && fail(res);
        },
        complete: function (res) {
            complete && complete(res);
        },
    });
};
var hide = function (options) {
    var success = options.success, fail = options.fail, complete = options.complete;
    try {
        queue = [];
        innerToast.switchToNext();
        success && success({ success: true });
        complete && complete({ success: true });
    }
    catch (e) {
        fail && fail(e);
        complete && complete(e);
    }
};

var navigateTo$7 = function (params) {
    var url = params.url, _a = params.isHash, isHash = _a === void 0 ? false : _a, _b = params.refresh, refresh = _b === void 0 ? true : _b, success = params.success, fail = params.fail, complete = params.complete;
    var _url = isHash ? "/#" + url : url;
    setTimeout(function () {
        try {
            if (refresh) {
                location.href = _url;
            }
            else {
                var state = { page_id: 1 };
                var title = '';
                history.pushState(state, title, _url);
            }
            success && success(params);
            complete && complete(params);
        }
        catch (e) {
            fail && fail(e);
            complete && complete(e);
        }
    });
};

var getLocation$1 = function (params) {
    var _a = params.success, success = _a === void 0 ? function () { } : _a, _b = params.fail, fail = _b === void 0 ? function () { } : _b, _c = params.complete, complete = _c === void 0 ? function () { } : _c;
    if ('geolocation' in navigator) {
        navigator.geolocation.getCurrentPosition(function (position) {
            var formatOutput = function (options) {
                var coords = position.coords || {};
                return {
                    longitude: coords.longitude,
                    latitude: coords.latitude,
                };
            };
            var onSuccess = enhanceSuccess(success, params, { formatOutput: formatOutput });
            onSuccess(position);
            complete(position);
        }, function (err) {
            if (err.code === 1) {
                err.errCode = 11;
                err.errMsg = 'permission deny';
            }
            fail(err);
            complete(err);
        });
    }
    else {
        var err = { code: -1, message: '地理位置服务不可用' };
        fail(err);
        complete(err);
    }
};

var clsPrefix$1 = '__uni_confirm';
var styles$1 = ("." + clsPrefix$1 + " {\n  position: fixed;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  -webkit-transform: translate(-50%, -50%);\n  background: #fff;\n  color: #000;\n  box-sizing: border-box;\n  border-radius: 12px;\n  z-index: 9999;\n  outline: none;\n  text-align: center;\n  width: 280px;\n  opacity: 0;\n  animation-duration: .3s;\n  animation-fill-mode: both;\n}\n." + clsPrefix$1 + "_mask {\n  content: \"\";\n  position: fixed;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  top: 0;\n  margin: auto;\n  display: block;\n  z-index: 9999;\n  background: #000;\n  opacity: 0;\n  animation-duration: .3s;\n  animation-fill-mode: both;\n}\n." + clsPrefix$1 + "_title {\n  padding: 28px 16px 16px;\n  font-weight: bold;\n}\n." + clsPrefix$1 + "_content {\n  color: #666;\n  padding: 0 16px;\n  margin-bottom: 28px;\n  word-break: break-all;\n  max-height: 200px;\n  overflow: scroll;\n}\n." + clsPrefix$1 + "_cancel {\n  display: inline-block;\n  font-weight: bold;\n  padding: 14px 0;\n  width: 50%;\n  box-sizing: border-box;\n  border-top: 1px solid #eee;\n  border-right: 1px solid #eee;\n}\n." + clsPrefix$1 + "_confirm {\n  display: inline-block;\n  font-weight: bold;\n  color: #576B95;\n  padding: 14px 0;\n  width: 50%;\n  box-sizing: border-box;\n  border-top: 1px solid #eee;\n}\n@keyframes " + clsPrefix$1 + "_in {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n@keyframes " + clsPrefix$1 + "_out {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n@keyframes " + clsPrefix$1 + "_fadeIn {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: .6;\n  }\n}\n@keyframes " + clsPrefix$1 + "_fadeOut {\n  0% {\n    opacity: .6;\n  }\n  100% {\n    opacity: 0;\n  }\n}").replace(/\n/g, '');
var styleElement$1 = null;
var confirmElement = null;
var hideFn$1 = function () { };
var confirm$1 = function (params) {
    var _a, _b;
    if (params === void 0) { params = {}; }
    try {
        if (!styleElement$1) {
            styleElement$1 = document.createElement('style');
            styleElement$1.innerHTML = styles$1;
            document.body.appendChild(styleElement$1);
        }
        if (!confirmElement) {
            confirmElement = document.createElement('div');
            var maskEle_1 = document.createElement('div');
            maskEle_1.className = clsPrefix$1 + "_mask";
            confirmElement.appendChild(maskEle_1);
            var containerEle_1 = document.createElement('div');
            containerEle_1.className = clsPrefix$1;
            var titleEle = document.createElement('div');
            titleEle.className = clsPrefix$1 + "_title";
            titleEle.innerText = params.title || '';
            containerEle_1.appendChild(titleEle);
            var contentEle = document.createElement('div');
            contentEle.className = clsPrefix$1 + "_content";
            contentEle.innerText = params.content || '';
            containerEle_1.appendChild(contentEle);
            var operateEle = document.createElement('div');
            var cancelButton = document.createElement('div');
            cancelButton.className = clsPrefix$1 + "_cancel";
            cancelButton.innerText = params.cancelButtonText || '';
            cancelButton.setAttribute('tabindex', '-1');
            cancelButton.addEventListener('click', function () {
                hideFn$1(function () {
                    var _a, _b;
                    (_a = params.success) === null || _a === void 0 ? void 0 : _a.call(params, { confirm: false });
                    (_b = params.complete) === null || _b === void 0 ? void 0 : _b.call(params, { confirm: false });
                });
            });
            operateEle.appendChild(cancelButton);
            var confirmButton = document.createElement('div');
            confirmButton.className = clsPrefix$1 + "_confirm";
            confirmButton.innerText = params.confirmButtonText || '';
            confirmButton.setAttribute('tabindex', '-1');
            confirmButton.addEventListener('click', function () {
                hideFn$1(function () {
                    var _a, _b;
                    (_a = params.success) === null || _a === void 0 ? void 0 : _a.call(params, { confirm: true });
                    (_b = params.complete) === null || _b === void 0 ? void 0 : _b.call(params, { confirm: true });
                });
            });
            operateEle.appendChild(confirmButton);
            containerEle_1.appendChild(operateEle);
            confirmElement.appendChild(containerEle_1);
            document.body.appendChild(confirmElement);
            maskEle_1.style.animationName = clsPrefix$1 + "_fadeIn";
            containerEle_1.style.animationName = clsPrefix$1 + "_in";
            hideFn$1 = function (callback) {
                maskEle_1.style.animationName = clsPrefix$1 + "_fadeOut";
                confirmElement === null || confirmElement === void 0 ? void 0 : confirmElement.removeChild(containerEle_1);
                setTimeout(function () {
                    var _a;
                    confirmElement && ((_a = document.body) === null || _a === void 0 ? void 0 : _a.removeChild(confirmElement));
                    confirmElement = null;
                    callback();
                }, 300);
            };
        }
    }
    catch (err) {
        (_a = params.fail) === null || _a === void 0 ? void 0 : _a.call(params, err);
        (_b = params.complete) === null || _b === void 0 ? void 0 : _b.call(params, err);
    }
};

function alert$1(params) {
    var content = params.content;
    window.alert(content);
}

var showLoading$1 = function (_a) {
    var _b = _a.content, content = _b === void 0 ? '' : _b; _a.delay; var _d = _a.success, success = _d === void 0 ? function () { } : _d, _e = _a.fail, fail = _e === void 0 ? function () { } : _e, _f = _a.complete, complete = _f === void 0 ? function () { } : _f;
    window.__uni_loadingWin = null;
    var clsPrefix = '__uni_loading';
    var styles = ("." + clsPrefix + " {\n    background-color: rgba(0, 0, 0, 0.6);\n    box-sizing: border-box;\n    max-width: 80%;\n    color: #ffffff;\n    padding: 15px;\n    position: fixed;\n    left: 50%;\n    bottom: 50%;\n    border-radius: 4px;\n    text-align: center;\n    transform: translateX(-50%);\n    -webkit-transform: translateX(-50%);\n    z-index: 9999;\n    outline: none;\n  }\n  ." + clsPrefix + "_circle {\n    border: 2px solid rgba(200, 200, 200, 0.5);\n    border-radius: 50%;\n    position: relative;\n    height: 40px;\n    width: 40px;\n    margin: auto;\n  }\n  ." + clsPrefix + "_circle:after {\n    content: \"\";\n    display: block;\n    border-radius: 50%;\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    top: -2px;\n    left: -2px;\n    border: 2px solid;\n    border-color: transparent;\n    border-left-color: #fff;\n    box-sizing: content-box;\n    animation: " + clsPrefix + "_roller 1s infinite linear;\n  }\n  ." + clsPrefix + "_text {\n    margin-top: 6px;\n    color: #fff;\n    line-height: 1.5;\n    font-size: 14px;\n    text-align: center;\n    font-weight: normal;\n  }\n  @keyframes " + clsPrefix + "_roller {\n    0% {\n      transform: rotateZ(0);\n    }\n    100% {\n      transform: rotateZ(360deg);\n    }\n  }").replace(/\n/g, '');
    var styleElement = null;
    try {
        if (!styleElement) {
            styleElement = document.createElement('style');
            styleElement.innerHTML = styles;
            document.body.appendChild(styleElement);
        }
        if (!window.__uni_loadingWin) {
            window.__uni_loadingWin = document.createElement('div');
            window.__uni_loadingWin.className = clsPrefix;
            window.__uni_loadingWin.setAttribute('role', 'alert');
            window.__uni_loadingWin.setAttribute('tabindex', '-1');
            var circle = document.createElement('div');
            circle.className = clsPrefix + "_circle";
            window.__uni_loadingWin.appendChild(circle);
            var text_1 = document.createElement('div');
            text_1.className = clsPrefix + "_text";
            window.__uni_loadingWin.appendChild(text_1);
            document.body.appendChild(window.__uni_loadingWin);
        }
        var text = window.__uni_loadingWin.querySelector("." + clsPrefix + "_text");
        if (content) {
            text.style.display = 'block';
            text.innerText = content;
        }
        else {
            text.style.display = 'none';
            text.innerText = '';
        }
        success();
        complete();
    }
    catch (error) {
        fail();
        complete();
    }
};

var hideLoading$1 = function (_a) {
    var _b = _a.success, success = _b === void 0 ? function () { } : _b, _c = _a.fail, fail = _c === void 0 ? function () { } : _c, _d = _a.complete, complete = _d === void 0 ? function () { } : _d;
    try {
        setTimeout(function () {
            if (window.__uni_loadingWin && window.__uni_loadingWin.parentNode) {
                window.__uni_loadingWin.parentNode.removeChild(window.__uni_loadingWin);
            }
            window.__uni_loadingWin = null;
            success();
            complete();
        }, 0);
    }
    catch (error) {
        fail();
        complete();
    }
};

var clsPrefix = '__uni_actionsheet';
var styles = ("." + clsPrefix + " {\n  position: fixed;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: #fff;\n  color: #000;\n  box-sizing: border-box;\n  border-radius: 12px 12px 0 0;\n  transform: translateY(100%);\n  -webkit-transform: translateY(100%);\n  z-index: 9999;\n  outline: none;\n  text-align: center;\n  animation-duration: .3s;\n  animation-fill-mode: both;\n}\n." + clsPrefix + "_mask {\n  content: \"\";\n  position: fixed;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  top: 0;\n  margin: auto;\n  display: block;\n  z-index: 9999;\n  background: #000;\n  opacity: 0;\n  animation-duration: .3s;\n  animation-fill-mode: both;\n}\n." + clsPrefix + "_item {\n  padding: 16px 0;\n  border-bottom: 1px solid #eee;\n}\n." + clsPrefix + "_cancel {\n  padding: 16px 0;\n  border-top: 10px solid #eee;\n}\n@keyframes " + clsPrefix + "_slideIn {\n  0% {\n    transform: translateY(100%);\n    -webkit-transform: translateY(100%);\n  }\n  100% {\n    transform: translateY(0);\n    -webkit-transform: translateY(0);\n  }\n}\n@keyframes " + clsPrefix + "_slideOut {\n  0% {\n    transform: translateY(0);\n    -webkit-transform: translateY(0);\n  }\n  100% {\n    transform: translateY(100%);\n    -webkit-transform: translateY(100%);\n  }\n}\n@keyframes " + clsPrefix + "_fadeIn {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: .6;\n  }\n}\n@keyframes " + clsPrefix + "_fadeOut {\n  0% {\n    opacity: .6;\n  }\n  100% {\n    opacity: 0;\n  }\n}").replace(/\n/g, '');
var styleElement = null;
var actionSheetElement = null;
var hideFn = function () { };
var hideCallback = function () { };
var showActionSheet$1 = function (params) {
    var _a, _b;
    try {
        if (!styleElement) {
            styleElement = document.createElement('style');
            styleElement.innerHTML = styles;
            document.body.appendChild(styleElement);
        }
        if (!actionSheetElement) {
            actionSheetElement = document.createElement('div');
            var maskEle_1 = document.createElement('div');
            maskEle_1.className = clsPrefix + "_mask";
            maskEle_1.addEventListener('click', function () {
                hideCallback(-1);
            });
            actionSheetElement.appendChild(maskEle_1);
            var containerEle_1 = document.createElement('div');
            containerEle_1.className = clsPrefix;
            var itemList = params.items || [];
            var _loop_1 = function (index) {
                var itemEle = document.createElement('div');
                itemEle.className = clsPrefix + "_item";
                itemEle.innerText = itemList[index];
                itemEle.setAttribute('tabindex', "" + index);
                itemEle.addEventListener('click', function () {
                    hideCallback(index);
                });
                containerEle_1.appendChild(itemEle);
            };
            for (var index = 0; index < itemList.length; index++) {
                _loop_1(index);
            }
            var cancelEle = document.createElement('div');
            cancelEle.className = clsPrefix + "_cancel";
            cancelEle.innerText = params.cancelButtonText || '取消';
            cancelEle.setAttribute('tabindex', '-1');
            cancelEle.addEventListener('click', function () {
                hideCallback(-1);
            });
            containerEle_1.appendChild(cancelEle);
            actionSheetElement.appendChild(containerEle_1);
            document.body.appendChild(actionSheetElement);
            maskEle_1.style.animationName = clsPrefix + "_fadeIn";
            containerEle_1.style.animationName = clsPrefix + "_slideIn";
            hideFn = function (callback) {
                maskEle_1.style.animationName = clsPrefix + "_fadeOut";
                containerEle_1.style.animationName = clsPrefix + "_slideOut";
                setTimeout(function () {
                    actionSheetElement && document.body.removeChild(actionSheetElement);
                    actionSheetElement = null;
                    callback();
                }, 300);
            };
            hideCallback = function (index) {
                hideFn(function () {
                    var _a, _b;
                    (_a = params.success) === null || _a === void 0 ? void 0 : _a.call(params, { index: index });
                    (_b = params.complete) === null || _b === void 0 ? void 0 : _b.call(params, { index: index });
                });
            };
        }
    }
    catch (err) {
        (_a = params.fail) === null || _a === void 0 ? void 0 : _a.call(params, err);
        (_b = params.complete) === null || _b === void 0 ? void 0 : _b.call(params, err);
    }
};

var redirectTo$1 = function (params) {
    var _a = params || {}, url = _a.url, _b = _a.isHash, isHash = _b === void 0 ? false : _b, _c = _a.refresh, refresh = _c === void 0 ? true : _c, success = _a.success, fail = _a.fail, complete = _a.complete;
    var _url = isHash ? "/#" + url : url;
    setTimeout(function () {
        try {
            history.replaceState('', '', _url);
            refresh && history.go(0);
            success && success(params);
            complete && complete(params);
        }
        catch (e) {
            fail && fail(e);
            complete && complete(e);
        }
    });
};

var getStorage$1 = function (params) {
    var _a, _b, _c, _d;
    try {
        if (Object.prototype.toString.call(params) !== '[object Object]') {
            throw new Error('the Function need a param of Object type');
        }
        if (!params.hasOwnProperty('key')) {
            throw new Error('the first param of this Function must contain a property named "key"');
        }
        if (typeof params.key !== 'string') {
            throw new Error('the first param of this Function must contain a property named "key" of string type');
        }
        var res = {
            data: JSON.parse(window.localStorage.getItem(params.key || '') || '{}'),
        };
        (_a = params.success) === null || _a === void 0 ? void 0 : _a.call(params, res);
        (_b = params.complete) === null || _b === void 0 ? void 0 : _b.call(params, res);
        return res;
    }
    catch (e) {
        (_c = params.fail) === null || _c === void 0 ? void 0 : _c.call(params, e);
        (_d = params.complete) === null || _d === void 0 ? void 0 : _d.call(params, e);
    }
};

var removeStorageSync$2 = function (params) {
    var _a = params || {}; _a.success; _a.fail; _a.complete;
    try {
        if (Object.prototype.toString.call(params) !== '[object Object]') {
            throw new Error('the Function need a param of Object type');
        }
        if (!params.hasOwnProperty('key')) {
            throw new Error('the first param of this Function must contain a property named "key"');
        }
        if (typeof params.key !== 'string') {
            throw new Error('the first param of this Function must contain a property named "key" of string type');
        }
        return window.localStorage.removeItem(params.key);
    }
    catch (e) {
        throw new Error(JSON.stringify(e || ''));
    }
};

var setStorage$1 = function (params) {
    var _a = params || {}, _b = _a.success, success = _b === void 0 ? function () { } : _b, _c = _a.fail, fail = _c === void 0 ? function () { } : _c, _d = _a.complete, complete = _d === void 0 ? function () { } : _d;
    try {
        if (Object.prototype.toString.call(params) !== '[object Object]') {
            throw new Error('the Function need a param of Object type');
        }
        if (!params.hasOwnProperty('key')) {
            throw new Error('the first param of this Function must contain a property named "key"');
        }
        if (typeof params.key !== 'string') {
            throw new Error('the first param of this Function must contain a property named "key" of string type');
        }
        if (!params.hasOwnProperty('data')) {
            throw new Error('the first param of this Function must contain a property named "data"');
        }
        window.localStorage.setItem(params.key, JSON.stringify(params.data || {}));
        success({ success: true });
        complete({ success: true });
    }
    catch (e) {
        fail(e);
        complete(e);
    }
};

function inputCreateAndAppend(multiple) {
    var inputElement = document.createElement('INPUT');
    inputElement.name = 'file';
    inputElement.id = "input-" + Math.random() * 1e8;
    inputElement.type = 'file';
    multiple && inputElement.setAttribute('multiple', 'multiple');
    inputElement.style.display = 'none';
    inputElement.setAttribute('accept', 'image/*');
    document.body.appendChild(inputElement);
    return inputElement;
}
function transformBase64(files) {
    return new Promise(function (resolve, reject) {
        !files.length && reject();
        var base64Array = [];
        var count = 0;
        files.forEach(function (file) {
            var reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = function (e) {
                base64Array.push(e.target.result);
            };
            reader.onloadend = function () {
                count++;
                if (count === files.length) {
                    resolve(base64Array);
                }
            };
        });
    });
}
var chooseImage$1 = function (params) {
    var _a = params.count, count = _a === void 0 ? 1 : _a; params.sourceType; var _c = params.success, success = _c === void 0 ? function () { } : _c, _d = params.fail, fail = _d === void 0 ? function () { } : _d, _e = params.complete, complete = _e === void 0 ? function () { } : _e;
    try {
        var inputElement_1 = inputCreateAndAppend(count > 1);
        var files_1 = [];
        inputElement_1.addEventListener('change', function (e) {
            files_1 = e.target.files && Array.from(e.target.files).slice(0, count);
            transformBase64(files_1)
                .then(function (base64Array) {
                var res = {
                    tempFilePaths: base64Array,
                    tempFiles: base64Array.map(function (filePath) { return ({
                        path: filePath,
                        size: filePath.length,
                    }); }),
                };
                success(res);
                complete(res);
            })
                .finally(function () { return inputElement_1.remove && inputElement_1.remove(); });
        }, false);
        var MouseEvents = document.createEvent('MouseEvents');
        MouseEvents.initEvent('click', true, true);
        inputElement_1.dispatchEvent(MouseEvents);
    }
    catch (e) {
        fail(e);
        complete(e);
    }
};

var getStorageSync$2 = function (params) {
    try {
        if (Object.prototype.toString.call(params) !== '[object Object]') {
            throw new Error('the Function need a param of Object type');
        }
        if (!params.hasOwnProperty('key')) {
            throw new Error('the first param of this Function must contain a property named "key"');
        }
        if (typeof params.key !== 'string') {
            throw new Error('the first param of this Function must contain a property named "key" of string type');
        }
        var res = {
            data: JSON.parse(window.localStorage.getItem(params.key || '') || '{}'),
        };
        return res;
        return res;
    }
    catch (e) {
        throw new Error(JSON.stringify(e || ''));
    }
};

var removeStorage$1 = function (params) {
    var _a = params || {}, _b = _a.success, success = _b === void 0 ? function () { } : _b, _c = _a.fail, fail = _c === void 0 ? function () { } : _c, _d = _a.complete, complete = _d === void 0 ? function () { } : _d;
    try {
        if (Object.prototype.toString.call(params) !== '[object Object]') {
            throw new Error('the Function need a param of Object type');
        }
        if (!params.hasOwnProperty('key')) {
            throw new Error('the first param of this Function must contain a property named "key"');
        }
        if (typeof params.key !== 'string') {
            throw new Error('the first param of this Function must contain a property named "key" of string type');
        }
        window.localStorage.removeItem(params.key);
        success({ success: true });
        complete({ success: true });
    }
    catch (e) {
        fail(e);
        complete(e);
    }
};

var setClipboard$1 = function (args) {
    var _a = args || {}, _b = _a.text, text = _b === void 0 ? '' : _b, _c = _a.success, success = _c === void 0 ? function () { } : _c, _d = _a.fail, fail = _d === void 0 ? function () { } : _d, _e = _a.complete, complete = _e === void 0 ? function () { } : _e;
    var input = document.createElement('input');
    input.setAttribute('readonly', 'readonly');
    input.setAttribute('value', text);
    input.style.position = 'fixed';
    input.style.height = '0px';
    document.body.appendChild(input);
    input.focus();
    input.setSelectionRange(0, -1);
    var removeInput = function () {
        document.body.removeChild(input);
    };
    try {
        if (document.execCommand('copy')) {
            removeInput();
            success({ success: true });
            complete({ success: true });
            return text;
        }
        else {
            removeInput();
            fail({
                errCode: 1,
                errMsg: 'not support'
            });
        }
    }
    catch (error) {
        removeInput();
        fail(false);
    }
};

var setStorageSync$2 = function (params) {
    var _a = params || {}; _a.success; var _c = _a.fail, fail = _c === void 0 ? function () { } : _c, _d = _a.complete, complete = _d === void 0 ? function () { } : _d;
    try {
        if (Object.prototype.toString.call(params) !== '[object Object]') {
            throw new Error('the Function need a param of Object type');
        }
        if (!params.hasOwnProperty('key')) {
            throw new Error('the first param of this Function must contain a property named "key"');
        }
        if (typeof params.key !== 'string') {
            throw new Error('the first param of this Function must contain a property named "key" of string type');
        }
        if (!params.hasOwnProperty('data')) {
            throw new Error('the first param of this Function must contain a property named "data"');
        }
        return window.localStorage.setItem(params.key, JSON.stringify(params.data || {}));
    }
    catch (e) {
        fail(e);
        complete(e);
    }
};

function getNetworkType$1(params) {
    var _a;
    var type = navigator.connection.effectiveType;
    if (type) {
        if (type === 'slow-2g') {
            type = '2g';
        }
    }
    else {
        type = navigator.connection.type || 'none';
        if (!['wifi', 'none'].includes(type)) {
            type = 'unknown';
        }
    }
    type = type.toUpperCase();
    (_a = params === null || params === void 0 ? void 0 : params.success) === null || _a === void 0 ? void 0 : _a.call(params, { networkType: type });
}

var showActionSheet;
if (isWeb) {
    if (isWindvane) {
        showActionSheet = showActionSheet$9;
    }
    else if (isNebula) {
        showActionSheet = showActionSheet$8;
    }
    else if (isFliggy) {
        showActionSheet = notSupport;
    }
    else if (isDingTalk) {
        showActionSheet = showActionSheet$7;
    }
    else if (isDingTalkPC) {
        showActionSheet = showActionSheet$6;
    }
    else {
        showActionSheet = showActionSheet$1;
    }
}
else if (isMini) {
    if (isMiniAli) {
        showActionSheet = showActionSheet$5;
    }
    else if (isMiniWx) {
        showActionSheet = showActionSheet$4;
    }
    else if (isMiniTt) {
        showActionSheet = showActionSheet$3;
    }
}
else if (isMiniweb) {
    showActionSheet = showActionSheet$2;
}
if (!showActionSheet) {
    showActionSheet = notSupport;
}
var index$L = promisifyApi(showActionSheet);

function getStatusBarHeight$2(params) {
    if (!isIOS) {
        var success = enhanceSuccess(params.success, params);
        success({ statusBarHeight: 0 });
    }
    else {
        return getStatusBarHeight$5(params);
    }
}
function previewImage$2(params) {
    var formatInput = function (_a) {
        var urls = _a.urls, current = _a.current;
        return {
            images: urls,
            index: +(current || 0),
        };
    };
    WVCall('WVUIImagepreview.showImagepreview', params, { formatInput: formatInput });
}
function scan$3(params) {
    var formatInput = function (_a) {
        var _b = _a.scanType, scanType = _b === void 0 ? ['qrCode', 'barCode'] : _b, _c = _a.hideAlbum, hideAlbum = _c === void 0 ? false : _c;
        return {
            type: scanType,
            hideAlbum: hideAlbum,
        };
    };
    var formatErrInfo = function (error) {
        var errorCode = error.msg === 'user abort' ? ERR_SCAN_USER_CANCEL : ERR_COMMON;
        var errorMsg = error.msg === 'user abort' ? ERR_MSG_CANCEL : ERR_MSG_COMMON;
        return {
            error: errorCode,
            errorMsg: errorMsg,
        };
    };
    WVCall('Scancode.scan', params, { formatInput: formatInput }, { formatOutput: formatErrInfo });
}
function setNaviBarRightItem$2(params) {
    var formatInput = function (_a) {
        var type = _a.type, iconBase64 = _a.iconBase64, title = _a.title;
        if (type === 'text') {
            return {
                title: type === 'text' && title,
            };
        }
        else {
            return {
                icon: type === 'icon' && iconBase64,
            };
        }
    };
    if (!window._uniapi_context) {
        window._uniapi_context = {};
    }
    if (!window._uniapi_context.events) {
        window._uniapi_context.events = {};
    }
    var lastHandler = window._uniapi_context.events.setNaviBarRightItem;
    if (typeof lastHandler === 'function') {
        document.removeEventListener('navbar-right-item-click', lastHandler);
    }
    var handler = params.onClick || function () { };
    document.addEventListener('TBNaviBar.rightItem.clicked', handler, false);
    return WVCall('WebAppInterface.setNaviBarRightItem', params, {
        formatInput: formatInput,
    });
}
function clearNaviBarRightItem$2(params) {
    WVCall('WebAppInterface.clearNaviBarRightItem', params);
}
function showTitle$2(params) {
    var formatInput = function () {
        return {
            hidden: '0',
            animated: '1',
        };
    };
    WVCall('WebAppInterface.setNaviBarHidden', params, { formatInput: formatInput });
}
function hideTitle$4(params) {
    var formatInput = function () {
        return {
            hidden: '1',
            animated: '1',
            statusBarHidden: '1',
        };
    };
    WVCall('WebAppInterface.setNaviBarHidden', params, { formatInput: formatInput });
}
function setNavigationBar$6(params) {
    WVCall('WebAppInterface.setCustomPageTitle', params);
}
function chooseCity$1(params) {
    var formatOutput = function (ret) {
        return {
            adCode: ret.cityCode,
            city: ret.cityName,
        };
    };
    WVCall('WVUICityList.showCityList', params, { formatOutput: formatOutput });
}
function showSharePanel$6(params) {
    WVCall('TBSharedModule.showSharedMenu', params);
}
function navigateTo$6(params) {
    WVCall('WVNative.openWindow', params);
}
function navigateBack$6(params) {
    WVCall('WVNative.nativeBack', params);
}
function getDeviceId$3(params) {
    var outputMap = { deviceId: 'deviceID' };
    WVCall('TBDeviceInfo.getInfo', params, {
        outputMap: outputMap,
    });
}
function playAudio$1(params) {
    var inputMap = {
        playIdentifier: ['identifier'],
    };
    return WVCall('H5AudioPlayer.play', params, { inputMap: inputMap });
}
function stopAudio$1(params) {
    var inputMap = {
        playIdentifier: ['identifier'],
    };
    return WVCall('H5AudioPlayer.stop', params, { inputMap: inputMap });
}

var stopAudio;
if (isWeb) {
    if (isWindvane) {
        if (isWebTb) {
            stopAudio = stopAudio$1;
        }
        else if (isWebLt) {
            stopAudio = stopAudio$1;
        }
        else {
            stopAudio = notSupport;
        }
    }
    else if (isNebula) {
        stopAudio = stopAudio$2;
    }
    else if (isFliggy) {
        stopAudio = notSupport;
    }
    else if (isDingTalk) {
        stopAudio = notSupport;
    }
    else if (isDingTalkPC) {
        stopAudio = notSupport;
    }
}
else if (isMini) {
    if (isMiniAli) {
        stopAudio = notSupport;
    }
    else if (isMiniWx) {
        stopAudio = notSupport;
    }
    else if (isMiniTt) {
        stopAudio = notSupport;
    }
}
if (!stopAudio) {
    stopAudio = notSupport;
}
var index$K = promisifyApi(stopAudio);
function hideTitle$3(params) {
    var formatInput = function () {
        return { visible: false };
    };
    return WVCall('WVIdleFishApi.setNavigationBarVisible', params, {
        formatInput: formatInput,
    });
}
function navigateBack$5(params) {
    return WVCall('WVIdleFishApi.finish', params);
}
function navigateTo$5(params) {
    return WVCall('Base.openWindow', params);
}
function setNavigationBar$5(params) {
    WVCall('WVIdleFishApi.setTitle', params);
}
function setNaviBarRightItem$1(params) {
    var formatInput = function (_a) {
        var type = _a.type; _a.iconBase64; var title = _a.title;
        return {
            title: type === 'text' && title,
            func: '_uniapi_context_onNaviRightItemClick',
        };
    };
    var handler = params.onClick || function () { };
    window._uniapi_context_onNaviRightItemClick = handler;
    return WVCall('WVIdleFishApi.setNavigatorRightItem', params, {
        formatInput: formatInput,
    });
}
function clearNaviBarRightItem$1(params) {
    WVCall('WVIdleFishApi.setHideNavigatorRightItem', params);
}
function showSharePanel$5(params) {
    var inputMap = {
        content: 'text',
    };
    WVCall('TBSharedModule.showSharedMenu', params, { inputMap: inputMap });
}
function getStatusBarHeight$1(params) {
    if (isIOS) {
        return getStatusBarHeight$5(params);
    }
    else {
        var outputMap = {
            statusBarHeight: 'height',
        };
        WVCall('WVIdleFishApi.getImmerseStatusBarHeight', params, { outputMap: outputMap });
    }
}

function navigateTo$4(params) {
    var url = params.url;
    if (!url) {
        return {
            errCode: '11',
            errMsg: '参数缺少 url',
        };
    }
    location.href = "eleme://web?url=" + encodeURIComponent(url);
    return {
        success: 1,
    };
}
function navigateBack$4(params) {
    WVCall('EleWVHybridAPI.popWindow', params, {});
}

var confirm;
if (isWeb) {
    if (isWindvane) {
        confirm = confirm$8;
    }
    else if (isNebula) {
        confirm = confirm$7;
    }
    else if (isFliggy) {
        confirm = confirm$6;
    }
    else if (isDingTalk) {
        confirm = confirm$5;
    }
    else if (isDingTalkPC) {
        confirm = confirm$4;
    }
    else {
        confirm = confirm$1;
    }
}
else if (isMini) {
    if (isMiniAli) {
        confirm = confirm$3;
    }
    else if (isMiniWx) {
        confirm = notSupport;
    }
    else if (isMiniTt) {
        confirm = notSupport;
    }
}
else if (isMiniweb) {
    confirm = confirm$2;
}
if (!confirm) {
    confirm = notSupport;
}
var index$I = promisifyApi(confirm);

var getStorage;
if (isWeb) {
    getStorage = getStorage$1;
}
else if (isMini) {
    if (isMiniAli) {
        getStorage = getStorage$4;
    }
    else if (isMiniWx) {
        getStorage = getStorage$3;
    }
    else if (isMiniTt) {
        getStorage = getStorage$2;
    }
}
if (!getStorage) {
    getStorage = notSupport;
}
var index$H = promisifyApi(getStorage);

var isAppInstalled;
if (isWeb) {
    if (isWindvane) {
        isAppInstalled = isAppInstalled$5;
    }
    else if (isNebula) {
        isAppInstalled = isAppInstalled$4;
    }
    else if (isFliggy) {
        isAppInstalled = isAppInstalled$3;
    }
    else if (isDingTalk) {
        isAppInstalled = isAppInstalled$2;
    }
    else if (isDingTalkPC) {
        isAppInstalled = isAppInstalled$1;
    }
}
else if (isMini) {
    if (isMiniAli) {
        isAppInstalled = notSupport;
    }
    else if (isMiniWx) {
        isAppInstalled = notSupport;
    }
    else if (isMiniTt) {
        isAppInstalled = notSupport;
    }
}
else if (isMiniweb) {
    isAppInstalled = notSupport;
}
if (!isAppInstalled) {
    isAppInstalled = notSupport;
}
var index$G = promisifyApi(isAppInstalled);

var redirectTo;
if (isWeb) {
    if (isWindvane) {
        redirectTo = redirectTo$8;
    }
    else if (isNebula) {
        redirectTo = redirectTo$7;
    }
    else if (isFliggy) {
        redirectTo = redirectTo$6;
    }
    else if (isDingTalk) {
        redirectTo = notSupport;
    }
    else if (isDingTalkPC) {
        redirectTo = notSupport;
    }
    else {
        redirectTo = redirectTo$1;
    }
}
else if (isMini) {
    if (isMiniAli) {
        redirectTo = redirectTo$5;
    }
    else if (isMiniWx) {
        redirectTo = redirectTo$4;
    }
    else if (isMiniTt) {
        redirectTo = redirectTo$3;
    }
}
else if (isMiniweb) {
    redirectTo = redirectTo$2;
}
if (!redirectTo) {
    redirectTo = notSupport;
}
var index$F = promisifyApi(redirectTo);

var setClipboard;
if (isWeb) {
    if (isWindvane) {
        setClipboard = setClipboard$9;
    }
    else if (isNebula) {
        setClipboard = setClipboard$8;
    }
    else if (isFliggy) {
        setClipboard = notSupport;
    }
    else if (isDingTalk) {
        setClipboard = setClipboard$7;
    }
    else if (isDingTalkPC) {
        setClipboard = setClipboard$6;
    }
    else {
        setClipboard = setClipboard$1;
    }
}
else if (isMini) {
    if (isMiniAli) {
        setClipboard = setClipboard$5;
    }
    else if (isMiniWx) {
        setClipboard = setClipboard$4;
    }
    else if (isMiniTt) {
        setClipboard = setClipboard$3;
    }
}
else if (isMiniweb) {
    setClipboard = setClipboard$2;
}
if (!setClipboard) {
    setClipboard = notSupport;
}
var index$E = promisifyApi(setClipboard);

var showLoading;
if (isWeb) {
    if (isWindvane) {
        showLoading = showLoading$a;
    }
    else if (isNebula) {
        showLoading = showLoading$9;
    }
    else if (isFliggy) {
        showLoading = showLoading$8;
    }
    else if (isDingTalk) {
        showLoading = showLoading$7;
    }
    else if (isDingTalkPC) {
        showLoading = showLoading$6;
    }
    else {
        showLoading = showLoading$1;
    }
}
else if (isMini) {
    if (isMiniAli) {
        showLoading = showLoading$5;
    }
    else if (isMiniWx) {
        showLoading = showLoading$4;
    }
    else if (isMiniTt) {
        showLoading = showLoading$3;
    }
}
else if (isMiniweb) {
    showLoading = showLoading$2;
}
if (!showLoading) {
    showLoading = notSupport;
}
var index$D = promisifyApi(showLoading);

var uploadImage;
if (isWeb) {
    if (isWindvane) {
        uploadImage = uploadImage$3;
    }
    else if (isNebula) {
        uploadImage = uploadImage$2;
    }
    else if (isFliggy) {
        uploadImage = notSupport;
    }
    else if (isDingTalk) {
        uploadImage = notSupport;
    }
    else if (isDingTalkPC) {
        uploadImage = notSupport;
    }
}
else if (isMini) {
    if (isMiniAli) {
        uploadImage = notSupport;
    }
    else if (isMiniWx) {
        uploadImage = notSupport;
    }
    else if (isMiniTt) {
        uploadImage = notSupport;
    }
}
else if (isMiniweb) {
    uploadImage = uploadImage$1;
}
if (!uploadImage) {
    uploadImage = notSupport;
}
var index$C = promisifyApi(uploadImage);

var chooseCity;
if (isWeb) {
    if (isWindvane) {
        if (isWebTb) {
            chooseCity = chooseCity$1;
        }
        else if (isWebAlipm) {
            chooseCity = chooseCity$1;
        }
        else {
            chooseCity = notSupport;
        }
    }
    else if (isNebula) {
        chooseCity = chooseCity$4;
    }
    else if (isFliggy) {
        chooseCity = notSupport;
    }
    else if (isDingTalk) {
        chooseCity = notSupport;
    }
    else if (isDingTalkPC) {
        chooseCity = notSupport;
    }
}
else if (isMini) {
    if (isMiniAli) {
        chooseCity = chooseCity$3;
    }
    else if (isMiniWx) {
        chooseCity = notSupport;
    }
    else if (isMiniTt) {
        chooseCity = notSupport;
    }
}
else if (isMiniweb) {
    chooseCity = chooseCity$2;
}
if (!chooseCity) {
    chooseCity = notSupport;
}
var index$B = promisifyApi(chooseCity);

var datePicker;
if (isMini) {
    if (isMiniAli) {
        datePicker = datePicker$1;
    }
}
if (!datePicker) {
    datePicker = notSupport;
}
var index$A = promisifyApi(datePicker);

var getStorageSync;
if (isWeb) {
    getStorageSync = getStorageSync$2;
}
else if (isMini) {
    if (isMiniAli) {
        getStorageSync = getStorageSync$5;
    }
    else if (isMiniWx) {
        getStorageSync = getStorageSync$4;
    }
    else if (isMiniTt) {
        getStorageSync = getStorageSync$3;
    }
}
if (!getStorageSync) {
    getStorageSync = notSupport;
}
var getStorageSync$1 = getStorageSync;

function setNavigationBar$4(params) {
    return WVCall('TMWVWindow.setTitle', params);
}
function hideTitle$2(params) {
    WVCall('TMWVWindow.hideTitle', params);
}
function showSharePanel$4(params) {
    var inputMap = {
        'all-link': 'url',
        'mobile-image': 'image',
        'share-title': 'title',
        'share-intro': 'content',
    };
    WVCall('TMShare.doShare', params, { inputMap: inputMap });
}
function navigateBack$3(params) {
    return WVCall('TMWVWindow.back', params);
}
function navigateTo$3(params) {
    return WVCall('Base.openWindow', params);
}

function setNavigationBar$3(params) {
    var formatInput = function (input) {
        return {
            type: 'text',
            content: input.title,
        };
    };
    WVCall('WVWDKHemaApi.setTitle', params, { formatInput: formatInput });
}
function showSharePanel$3(params) {
    var formatInput = function (_a) {
        var title = _a.title, content = _a.content, image = _a.image, url = _a.url;
        return {
            shareType: 'url',
            showShareButton: false,
            shareTitle: title,
            shareContent: content,
            sharePicUrl: image,
            shareString: url,
        };
    };
    WVCall('WVWDKHemaApi.WDKShareComponent', params, { formatInput: formatInput });
}
function navigateTo$2(params) {
    var formatInput = function (_a) {
        _a.url;
        return {
            url: params.url,
            popBeforeOpen: false,
        };
    };
    WVCall('WVWDKHemaApi.openWindow', params, { formatInput: formatInput });
}
function navigateBack$2(params) {
    WVCall('WVWDKHemaApi.finish', params);
}
function previewImage$1(params) {
    var inputMap = { index: 'init', images: ' urls' };
    WVCall('HMWVUIImagePreview.previewImage', params, { inputMap: inputMap });
}
function getDeviceId$2(params) {
    var outputMap = {
        deviceId: ['deviceID'],
    };
    return WVCall('WVWDKHemaApi.WDKDeviceInfo', params, { outputMap: outputMap });
}
function scan$2(params) {
    var formatInput = function () {
        return {
            needResult: true,
        };
    };
    var outputMap = {
        code: 'scanResult',
    };
    return WVCall('HMWVScan.scan', params, { formatInput: formatInput, outputMap: outputMap });
}

function setNavigationBar$2(params) {
    var inputMap = { setText: 'title' };
    return WVCall('YKWebAppInterface.setTitleBar', params, { inputMap: inputMap });
}
function showTitle$1(params) {
    var formatInput = function () {
        return {
            showTitle: true,
        };
    };
    return WVCall('YKWebAppInterface.setTitleBar', params, { formatInput: formatInput });
}
function hideTitle$1(params) {
    var formatInput = function () {
        return { showTitle: false };
    };
    var formatOutput = function () {
        return {
            isStatusBarHidden: false,
        };
    };
    return WVCall('YKWebAppInterface.setTitleBar', params, {
        formatInput: formatInput,
        formatOutput: formatOutput,
    });
}
function showSharePanel$2(params) {
    var formatInput = function (_a) {
        var title = _a.title, content = _a.content, image = _a.image, url = _a.url;
        return {
            titleText: title,
            descText: content,
            thumbnailUrl: image,
            url: url,
            sourceId: 10,
        };
    };
    return WVCall('WVBehavioursBridge.showShareView', params, { formatInput: formatInput });
}
function navigateTo$1(params) {
    var api = 'DYKBaseJSBridge.nativeOpen';
    var formatInput = function (options) {
        return {
            url: isAndroid ? options.url : "youku://http?url=" + options.url,
        };
    };
    if (isAndroid) {
        api = 'AliPayTransferJSBridge.openNewH5Page';
    }
    return WVCall(api, params, { formatInput: formatInput });
}
function navigateBack$1(params) {
    return WVCall('WVActionJSBridge.close', params);
}
function getDeviceId$1(params) {
    var outputMap = {
        deviceId: 'deviceID',
    };
    WVCall('DYKBaseJSBridge.getDeviceInfo', params, { outputMap: outputMap });
}

var navigateBack;
if (isWeb) {
    if (isWindvane) {
        if (isWebTb) {
            navigateBack = navigateBack$6;
        }
        else if (isWebTm) {
            navigateBack = navigateBack$3;
        }
        else if (isWebWdkhema) {
            navigateBack = navigateBack$2;
        }
        else if (isWebYouku) {
            navigateBack = navigateBack$1;
        }
        else if (isWebFm) {
            navigateBack = navigateBack$5;
        }
        else if (isWebLt) {
            navigateBack = navigateBack$6;
        }
        else if (isWebElmc) {
            navigateBack = navigateBack$4;
        }
        else if (isWebIhome) {
            navigateBack = navigateBack$6;
        }
        else if (isWebTphome) {
            navigateBack = navigateBack$6;
        }
        else if (isWebAh) {
            navigateBack = navigateBack$6;
        }
        else if (isWebAlipm) {
            navigateBack = navigateBack$6;
        }
        else {
            navigateBack = notSupport;
        }
    }
    else if (isNebula) {
        navigateBack = navigateBack$e;
    }
    else if (isFliggy) {
        navigateBack = navigateBack$d;
    }
    else if (isDingTalk) {
        navigateBack = navigateBack$c;
    }
    else if (isDingTalkPC) {
        navigateBack = navigateBack$b;
    }
}
else if (isMini) {
    if (isMiniAli) {
        navigateBack = navigateBack$a;
    }
    else if (isMiniWx) {
        navigateBack = navigateBack$9;
    }
    else if (isMiniTt) {
        navigateBack = navigateBack$8;
    }
}
else if (isMiniweb) {
    navigateBack = navigateBack$7;
}
if (!navigateBack) {
    navigateBack = notSupport;
}
var index$z = promisifyApi(navigateBack);

var removeStorage;
if (isWeb) {
    removeStorage = removeStorage$1;
}
else if (isMini) {
    if (isMiniAli) {
        removeStorage = removeStorage$4;
    }
    else if (isMiniWx) {
        removeStorage = removeStorage$3;
    }
    else if (isMiniTt) {
        removeStorage = removeStorage$2;
    }
}
if (!removeStorage) {
    removeStorage = notSupport;
}
var index$y = promisifyApi(removeStorage);

function scan$1(params) {
    var formatInput = function (_a) {
        var _b = _a.scanType, scanType = _b === void 0 ? 'qr' : _b, _c = _a.hideAlbum, hideAlbum = _c === void 0 ? false : _c;
        return {
            type: scanType === 'qr' ? '512' : scanType === 'bar' ? '255' : '767',
            hideAlbum: hideAlbum,
        };
    };
    WVCall('CUNScan.scan', params, { formatInput: formatInput });
}
function setNavigationBar$1(params) {
    var formatInput = function (_a) {
        var _b = _a.iconType, iconType = _b === void 0 ? 'Base 64' : _b;
        return { iconType: iconType };
    };
    return WVCall('WebAppInterface.setCustomPageTitle', params, { formatInput: formatInput });
}
function showSharePanel$1(params) {
    var inputMap = {
        imageUrl: 'image',
        pageUrl: 'url',
        taopasswordPicUrl: 'image',
    };
    return WVCall('CunpartnerShare.startShare', params, {
        inputMap: inputMap,
    });
}

var setNaviBarRightItem;
if (isWeb) {
    if (isWindvane) {
        if (isWebTb) {
            setNaviBarRightItem = setNaviBarRightItem$2;
        }
        else if (isWebCunpartner) {
            setNaviBarRightItem = setNaviBarRightItem$2;
        }
        else if (isWebFm) {
            setNaviBarRightItem = setNaviBarRightItem$1;
        }
        else if (isWebLt) {
            setNaviBarRightItem = setNaviBarRightItem$2;
        }
        else if (isWebElmc) {
            setNaviBarRightItem = setNaviBarRightItem$2;
        }
        else if (isWebIhome) {
            setNaviBarRightItem = setNaviBarRightItem$2;
        }
        else if (isWebTphome) {
            setNaviBarRightItem = setNaviBarRightItem$2;
        }
        else if (isWebAh) {
            setNaviBarRightItem = setNaviBarRightItem$2;
        }
        else if (isWebAlipm) {
            setNaviBarRightItem = setNaviBarRightItem$2;
        }
        else {
            setNaviBarRightItem = notSupport;
        }
    }
    else if (isNebula) {
        setNaviBarRightItem = setNaviBarRightItem$6;
    }
    else if (isFliggy) {
        setNaviBarRightItem = setNaviBarRightItem$5;
    }
    else if (isDingTalk) {
        setNaviBarRightItem = setNaviBarRightItem$4;
    }
    else if (isDingTalkPC) {
        setNaviBarRightItem = setNaviBarRightItem$3;
    }
}
else if (isMini) {
    if (isMiniAli) {
        setNaviBarRightItem = notSupport;
    }
    else if (isMiniWx) {
        setNaviBarRightItem = notSupport;
    }
    else if (isMiniTt) {
        setNaviBarRightItem = notSupport;
    }
}
else if (isMiniweb) {
    setNaviBarRightItem = notSupport;
}
if (!setNaviBarRightItem) {
    setNaviBarRightItem = notSupport;
}
var index$x = promisifyApi(setNaviBarRightItem);

var showNavigationBarLoading;
if (isWeb) {
    if (isWindvane) {
        showNavigationBarLoading = notSupport;
    }
    else if (isNebula) {
        showNavigationBarLoading = notSupport;
    }
    else if (isFliggy) {
        showNavigationBarLoading = notSupport;
    }
    else if (isDingTalk) {
        showNavigationBarLoading = notSupport;
    }
    else if (isDingTalkPC) {
        showNavigationBarLoading = notSupport;
    }
}
else if (isMini) {
    if (isMiniAli) {
        showNavigationBarLoading = showNavigationBarLoading$2;
    }
    else if (isMiniWx) {
        showNavigationBarLoading = notSupport;
    }
    else if (isMiniTt) {
        showNavigationBarLoading = notSupport;
    }
}
else if (isMiniweb) {
    showNavigationBarLoading = showNavigationBarLoading$1;
}
if (!showNavigationBarLoading) {
    showNavigationBarLoading = notSupport;
}
var index$w = promisifyApi(showNavigationBarLoading);

var vibrate;
if (isWeb) {
    if (isWindvane) {
        vibrate = vibrate$7;
    }
    else if (isNebula) {
        vibrate = vibrate$6;
    }
    else if (isFliggy) {
        vibrate = vibrate$5;
    }
    else if (isDingTalk) {
        vibrate = vibrate$4;
    }
    else if (isDingTalkPC) {
        vibrate = vibrate$3;
    }
}
else if (isMini) {
    if (isMiniAli) {
        vibrate = vibrate$2;
    }
    else if (isMiniWx) {
        vibrate = notSupport;
    }
    else if (isMiniTt) {
        vibrate = notSupport;
    }
}
else if (isMiniweb) {
    vibrate = vibrate$1;
}
if (!vibrate) {
    vibrate = notSupport;
}
var index$v = promisifyApi(vibrate);

var chooseImage;
if (isWeb) {
    if (isWindvane) {
        chooseImage = chooseImage$8;
    }
    else if (isNebula) {
        chooseImage = chooseImage$7;
    }
    else if (isFliggy) {
        chooseImage = chooseImage$6;
    }
    else if (isDingTalk) {
        chooseImage = notSupport;
    }
    else if (isDingTalkPC) {
        chooseImage = notSupport;
    }
    else {
        chooseImage = chooseImage$1;
    }
}
else if (isMini) {
    if (isMiniAli) {
        chooseImage = chooseImage$5;
    }
    else if (isMiniWx) {
        chooseImage = chooseImage$4;
    }
    else if (isMiniTt) {
        chooseImage = chooseImage$3;
    }
}
else if (isMiniweb) {
    chooseImage = chooseImage$2;
}
if (!chooseImage) {
    chooseImage = notSupport;
}
var index$u = promisifyApi(chooseImage);

var hideLoading;
if (isWeb) {
    if (isWindvane) {
        hideLoading = hideLoading$9;
    }
    else if (isNebula) {
        hideLoading = hideLoading$8;
    }
    else if (isFliggy) {
        hideLoading = notSupport;
    }
    else if (isDingTalk) {
        hideLoading = hideLoading$7;
    }
    else if (isDingTalkPC) {
        hideLoading = hideLoading$6;
    }
    else {
        hideLoading = hideLoading$1;
    }
}
else if (isMini) {
    if (isMiniAli) {
        hideLoading = hideLoading$5;
    }
    else if (isMiniWx) {
        hideLoading = hideLoading$4;
    }
    else if (isMiniTt) {
        hideLoading = hideLoading$3;
    }
}
else if (isMiniweb) {
    hideLoading = hideLoading$2;
}
if (!hideLoading) {
    hideLoading = notSupport;
}
var index$t = promisifyApi(hideLoading);

var navigateTo;
if (isWeb) {
    if (isWindvane) {
        if (isWebTb) {
            navigateTo = navigateTo$6;
        }
        else if (isWebWdkhema) {
            navigateTo = navigateTo$2;
        }
        else if (isWebYouku) {
            navigateTo = navigateTo$1;
        }
        else if (isWebFm) {
            navigateTo = navigateTo$5;
        }
        else if (isWebCunpartner) {
            navigateTo = navigateTo$6;
        }
        else if (isWebLt) {
            navigateTo = navigateTo$6;
        }
        else if (isWebElmc) {
            navigateTo = navigateTo$4;
        }
        else if (isWebIhome) {
            navigateTo = navigateTo$6;
        }
        else if (isWebTphome) {
            navigateTo = navigateTo$6;
        }
        else if (isWebAh) {
            navigateTo = navigateTo$6;
        }
        else if (isWebTm) {
            navigateTo = navigateTo$3;
        }
        else if (isWebAlipm) {
            navigateTo = navigateTo$6;
        }
        else {
            navigateTo = notSupport;
        }
    }
    else if (isNebula) {
        navigateTo = navigateTo$f;
    }
    else if (isFliggy) {
        navigateTo = navigateTo$e;
    }
    else if (isDingTalk) {
        navigateTo = navigateTo$d;
    }
    else if (isDingTalkPC) {
        navigateTo = navigateTo$c;
    }
    else {
        navigateTo = navigateTo$7;
    }
}
else if (isMini) {
    if (isMiniAli) {
        navigateTo = navigateTo$b;
    }
    else if (isMiniWx) {
        navigateTo = navigateTo$a;
    }
    else if (isMiniTt) {
        navigateTo = navigateTo$9;
    }
}
else if (isMiniweb) {
    navigateTo = navigateTo$8;
}
if (!navigateTo) {
    navigateTo = notSupport;
}
var index$s = promisifyApi(navigateTo);

var removeStorageSync;
if (isWeb) {
    removeStorageSync = removeStorageSync$2;
}
else if (isMini) {
    if (isMiniAli) {
        removeStorageSync = removeStorageSync$5;
    }
    else if (isMiniWx) {
        removeStorageSync = removeStorageSync$4;
    }
    else if (isMiniTt) {
        removeStorageSync = removeStorageSync$3;
    }
}
if (!removeStorageSync) {
    removeStorageSync = notSupport;
}
var removeStorageSync$1 = removeStorageSync;

var setNavigationBar;
if (isWeb) {
    if (isWindvane) {
        if (isWebTb) {
            setNavigationBar = setNavigationBar$6;
        }
        else if (isWebTm) {
            setNavigationBar = setNavigationBar$4;
        }
        else if (isWebWdkhema) {
            setNavigationBar = setNavigationBar$3;
        }
        else if (isWebYouku) {
            setNavigationBar = setNavigationBar$2;
        }
        else if (isWebCunpartner) {
            setNavigationBar = setNavigationBar$1;
        }
        else if (isWebFm) {
            setNavigationBar = setNavigationBar$5;
        }
        else if (isWebLt) {
            setNavigationBar = setNavigationBar$6;
        }
        else if (isWebElmc) {
            setNavigationBar = setNavigationBar$6;
        }
        else if (isWebIhome) {
            setNavigationBar = setNavigationBar$6;
        }
        else if (isWebTphome) {
            setNavigationBar = setNavigationBar$6;
        }
        else if (isWebAh) {
            setNavigationBar = setNavigationBar$6;
        }
        else {
            setNavigationBar = setNavigationBar$f;
        }
    }
    else if (isNebula) {
        setNavigationBar = setNavigationBar$e;
    }
    else if (isFliggy) {
        setNavigationBar = setNavigationBar$d;
    }
    else if (isDingTalk) {
        setNavigationBar = setNavigationBar$c;
    }
    else if (isDingTalkPC) {
        setNavigationBar = setNavigationBar$b;
    }
}
else if (isMini) {
    if (isMiniAli) {
        setNavigationBar = setNavigationBar$a;
    }
    else if (isMiniWx) {
        setNavigationBar = setNavigationBar$9;
    }
    else if (isMiniTt) {
        setNavigationBar = setNavigationBar$8;
    }
}
else if (isMiniweb) {
    setNavigationBar = setNavigationBar$7;
}
if (!setNavigationBar) {
    setNavigationBar = notSupport;
}
var index$r = promisifyApi(setNavigationBar);

var showSharePanel;
if (isWeb) {
    if (isWindvane) {
        if (isWebTb) {
            showSharePanel = showSharePanel$6;
        }
        else if (isWebTm) {
            showSharePanel = showSharePanel$4;
        }
        else if (isWebWdkhema) {
            showSharePanel = showSharePanel$3;
        }
        else if (isWebYouku) {
            showSharePanel = showSharePanel$2;
        }
        else if (isWebCunpartner) {
            showSharePanel = showSharePanel$1;
        }
        else if (isWebLt) {
            showSharePanel = showSharePanel$6;
        }
        else if (isWebElmc) {
            showSharePanel = showSharePanel$6;
        }
        else if (isWebIhome) {
            showSharePanel = showSharePanel$6;
        }
        else if (isWebTphome) {
            showSharePanel = showSharePanel$6;
        }
        else if (isWebFm) {
            showSharePanel = showSharePanel$5;
        }
        else if (isWebAlipm) {
            showSharePanel = showSharePanel$6;
        }
        else if (isWebQn) {
            showSharePanel = showSharePanel$6;
        }
        else {
            showSharePanel = notSupport;
        }
    }
    else if (isNebula) {
        showSharePanel = showSharePanel$e;
    }
    else if (isFliggy) {
        showSharePanel = showSharePanel$d;
    }
    else if (isDingTalk) {
        showSharePanel = showSharePanel$c;
    }
    else if (isDingTalkPC) {
        showSharePanel = showSharePanel$b;
    }
}
else if (isMini) {
    if (isMiniAli) {
        showSharePanel = showSharePanel$a;
    }
    else if (isMiniWx) {
        showSharePanel = showSharePanel$9;
    }
    else if (isMiniTt) {
        showSharePanel = showSharePanel$8;
    }
}
else if (isMiniweb) {
    showSharePanel = showSharePanel$7;
}
if (!showSharePanel) {
    showSharePanel = notSupport;
}
var index$q = promisifyApi(showSharePanel);

var vibrateLong;
if (isWeb) {
    if (isWindvane) {
        vibrateLong = notSupport;
    }
    else if (isNebula) {
        vibrateLong = notSupport;
    }
    else if (isFliggy) {
        vibrateLong = notSupport;
    }
    else if (isDingTalk) {
        vibrateLong = notSupport;
    }
    else if (isDingTalkPC) {
        vibrateLong = notSupport;
    }
}
else if (isMini) {
    if (isMiniAli) {
        vibrateLong = vibrateLong$4;
    }
    else if (isMiniWx) {
        vibrateLong = vibrateLong$3;
    }
    else if (isMiniTt) {
        vibrateLong = vibrateLong$2;
    }
}
else if (isMiniweb) {
    vibrateLong = vibrateLong$1;
}
if (!vibrateLong) {
    vibrateLong = notSupport;
}
var index$p = promisifyApi(vibrateLong);

var choosePhoneContact;
if (isWeb) {
    if (isWindvane) {
        if (isWebFm) {
            choosePhoneContact = notSupport;
        }
        else {
            choosePhoneContact = choosePhoneContact$9;
        }
    }
    else if (isNebula) {
        choosePhoneContact = choosePhoneContact$8;
    }
    else if (isFliggy) {
        choosePhoneContact = choosePhoneContact$7;
    }
    else if (isDingTalk) {
        choosePhoneContact = choosePhoneContact$6;
    }
    else if (isDingTalkPC) {
        choosePhoneContact = choosePhoneContact$5;
    }
}
else if (isMini) {
    if (isMiniAli) {
        choosePhoneContact = choosePhoneContact$4;
    }
    else if (isMiniWx) {
        choosePhoneContact = choosePhoneContact$3;
    }
    else if (isMiniTt) {
        choosePhoneContact = choosePhoneContact$2;
    }
}
else if (isMiniweb) {
    choosePhoneContact = choosePhoneContact$1;
}
if (!choosePhoneContact) {
    choosePhoneContact = notSupport;
}
var index$o = promisifyApi(choosePhoneContact);

var getDeviceId;
if (isWeb) {
    if (isWindvane) {
        if (isWebTb) {
            getDeviceId = getDeviceId$3;
        }
        else if (isWebWdkhema) {
            getDeviceId = getDeviceId$2;
        }
        else if (isWebYouku) {
            getDeviceId = getDeviceId$1;
        }
        else if (isWebFm) {
            getDeviceId = getDeviceId$3;
        }
        else if (isWebLt) {
            getDeviceId = getDeviceId$3;
        }
        else if (isWebElmc) {
            getDeviceId = getDeviceId$3;
        }
        else if (isWebIhome) {
            getDeviceId = getDeviceId$3;
        }
        else if (isWebTphome) {
            getDeviceId = getDeviceId$3;
        }
        else if (isWebCunpartner) {
            getDeviceId = notSupport;
        }
        else if (isWebAh) {
            getDeviceId = getDeviceId$3;
        }
        else {
            getDeviceId = notSupport;
        }
    }
    else if (isNebula) {
        getDeviceId = getDeviceId$5;
    }
    else if (isFliggy) {
        getDeviceId = getDeviceId$4;
    }
    else if (isDingTalk) {
        getDeviceId = notSupport;
    }
    else if (isDingTalkPC) {
        getDeviceId = notSupport;
    }
}
else if (isMini) {
    if (isMiniAli) {
        getDeviceId = notSupport;
    }
    else if (isMiniWx) {
        getDeviceId = notSupport;
    }
    else if (isMiniTt) {
        getDeviceId = notSupport;
    }
}
else if (isMiniweb) {
    getDeviceId = notSupport;
}
if (!getDeviceId) {
    getDeviceId = notSupport;
}
var index$n = promisifyApi(getDeviceId);

var hideNavigationBarLoading;
if (isWeb) {
    if (isWindvane) {
        hideNavigationBarLoading = notSupport;
    }
    else if (isNebula) {
        hideNavigationBarLoading = notSupport;
    }
    else if (isFliggy) {
        hideNavigationBarLoading = notSupport;
    }
    else if (isDingTalk) {
        hideNavigationBarLoading = notSupport;
    }
    else if (isDingTalkPC) {
        hideNavigationBarLoading = notSupport;
    }
}
else if (isMini) {
    if (isMiniAli) {
        hideNavigationBarLoading = hideNavigationBarLoading$2;
    }
    else if (isMiniWx) {
        hideNavigationBarLoading = notSupport;
    }
    else if (isMiniTt) {
        hideNavigationBarLoading = notSupport;
    }
}
else if (isMiniweb) {
    hideNavigationBarLoading = hideNavigationBarLoading$1;
}
if (!hideNavigationBarLoading) {
    hideNavigationBarLoading = notSupport;
}
var index$m = promisifyApi(hideNavigationBarLoading);

var openInBrowser;
if (isWeb) {
    if (isWindvane) {
        openInBrowser = openInBrowser$3;
    }
    else if (isNebula) {
        openInBrowser = openInBrowser$2;
    }
    else if (isFliggy) {
        openInBrowser = openInBrowser$1;
    }
    else if (isDingTalk) {
        openInBrowser = notSupport;
    }
    else if (isDingTalkPC) {
        openInBrowser = notSupport;
    }
}
else if (isMini) {
    if (isMiniAli) {
        openInBrowser = notSupport;
    }
    else if (isMiniWx) {
        openInBrowser = notSupport;
    }
    else if (isMiniTt) {
        openInBrowser = notSupport;
    }
}
else if (isMiniweb) {
    openInBrowser = notSupport;
}
if (!openInBrowser) {
    openInBrowser = notSupport;
}
var index$l = promisifyApi(openInBrowser);

var resumeAudio;
if (isWeb) {
    if (isWindvane) {
        if (isWebTb) {
            resumeAudio = notSupport;
        }
        else {
            resumeAudio = notSupport;
        }
    }
    else if (isNebula) {
        resumeAudio = resumeAudio$1;
    }
    else if (isFliggy) {
        resumeAudio = notSupport;
    }
    else if (isDingTalk) {
        resumeAudio = notSupport;
    }
    else if (isDingTalkPC) {
        resumeAudio = notSupport;
    }
}
else if (isMini) {
    if (isMiniAli) {
        resumeAudio = notSupport;
    }
    else if (isMiniWx) {
        resumeAudio = notSupport;
    }
    else if (isMiniTt) {
        resumeAudio = notSupport;
    }
}
if (!resumeAudio) {
    resumeAudio = notSupport;
}
var index$k = promisifyApi(resumeAudio);

var setOrientation;
if (isWeb) {
    if (isWindvane) {
        setOrientation = setOrientation$1;
    }
    else if (isNebula) {
        setOrientation = notSupport;
    }
    else if (isFliggy) {
        setOrientation = notSupport;
    }
    else if (isDingTalk) {
        setOrientation = notSupport;
    }
    else if (isDingTalkPC) {
        setOrientation = notSupport;
    }
}
else if (isMini) {
    if (isMiniAli) {
        setOrientation = notSupport;
    }
    else if (isMiniWx) {
        setOrientation = notSupport;
    }
    else if (isMiniTt) {
        setOrientation = notSupport;
    }
}
else if (isMiniweb) {
    setOrientation = notSupport;
}
if (!setOrientation) {
    setOrientation = notSupport;
}
var index$j = promisifyApi(setOrientation);

var showTitle;
if (isWeb) {
    if (isWindvane) {
        if (isWebTb) {
            showTitle = showTitle$2;
        }
        else if (isWebTm) {
            showTitle = notSupport;
        }
        else if (isWebYouku) {
            showTitle = showTitle$1;
        }
        else if (isWebFm) {
            showTitle = notSupport;
        }
        else if (isWebCunpartner) {
            showTitle = showTitle$2;
        }
        else if (isWebElmc) {
            showTitle = showTitle$2;
        }
        else if (isWebIhome) {
            showTitle = showTitle$2;
        }
        else if (isWebTphome) {
            showTitle = showTitle$2;
        }
        else if (isWebAh) {
            showTitle = showTitle$2;
        }
        else if (isWebAlipm) {
            showTitle = showTitle$2;
        }
        else {
            showTitle = notSupport;
        }
    }
    else if (isNebula) {
        showTitle = notSupport;
    }
    else if (isFliggy) {
        showTitle = showTitle$3;
    }
    else if (isDingTalk) {
        showTitle = notSupport;
    }
    else if (isDingTalkPC) {
        showTitle = notSupport;
    }
}
else if (isMini) {
    if (isMiniAli) {
        showTitle = notSupport;
    }
    else if (isMiniWx) {
        showTitle = notSupport;
    }
    else if (isMiniTt) {
        showTitle = notSupport;
    }
}
else if (isMiniweb) {
    showTitle = notSupport;
}
if (!showTitle) {
    showTitle = notSupport;
}
var index$i = promisifyApi(showTitle);

var vibrateShort;
if (isWeb) {
    if (isWindvane) {
        vibrateShort = notSupport;
    }
    else if (isNebula) {
        vibrateShort = notSupport;
    }
    else if (isFliggy) {
        vibrateShort = notSupport;
    }
    else if (isDingTalk) {
        vibrateShort = notSupport;
    }
    else if (isDingTalkPC) {
        vibrateShort = notSupport;
    }
}
else if (isMini) {
    if (isMiniAli) {
        vibrateShort = vibrateShort$4;
    }
    else if (isMiniWx) {
        vibrateShort = vibrateShort$3;
    }
    else if (isMiniTt) {
        vibrateShort = vibrateShort$2;
    }
}
else if (isMiniweb) {
    vibrateShort = vibrateShort$1;
}
if (!vibrateShort) {
    vibrateShort = notSupport;
}
var index$h = promisifyApi(vibrateShort);

var clearNaviBarRightItem;
if (isWeb) {
    if (isWindvane) {
        if (isWebTb) {
            clearNaviBarRightItem = clearNaviBarRightItem$2;
        }
        else if (isWebFm) {
            clearNaviBarRightItem = clearNaviBarRightItem$1;
        }
        else if (isWebLt) {
            clearNaviBarRightItem = clearNaviBarRightItem$2;
        }
        else if (isWebElmc) {
            clearNaviBarRightItem = clearNaviBarRightItem$2;
        }
        else if (isWebIhome) {
            clearNaviBarRightItem = clearNaviBarRightItem$2;
        }
        else if (isWebTphome) {
            clearNaviBarRightItem = clearNaviBarRightItem$2;
        }
        else if (isWebCunpartner) {
            clearNaviBarRightItem = clearNaviBarRightItem$2;
        }
        else if (isWebAh) {
            clearNaviBarRightItem = clearNaviBarRightItem$2;
        }
        else if (isWebAlipm) {
            clearNaviBarRightItem = clearNaviBarRightItem$2;
        }
        else {
            clearNaviBarRightItem = notSupport;
        }
    }
    else if (isNebula) {
        clearNaviBarRightItem = clearNaviBarRightItem$6;
    }
    else if (isFliggy) {
        clearNaviBarRightItem = clearNaviBarRightItem$5;
    }
    else if (isDingTalk) {
        clearNaviBarRightItem = clearNaviBarRightItem$4;
    }
    else if (isDingTalkPC) {
        clearNaviBarRightItem = clearNaviBarRightItem$3;
    }
}
else if (isMini) {
    if (isMiniAli) {
        clearNaviBarRightItem = notSupport;
    }
    else if (isMiniWx) {
        clearNaviBarRightItem = notSupport;
    }
    else if (isMiniTt) {
        clearNaviBarRightItem = notSupport;
    }
}
else if (isMiniweb) {
    clearNaviBarRightItem = notSupport;
}
if (!clearNaviBarRightItem) {
    clearNaviBarRightItem = notSupport;
}
var index$g = promisifyApi(clearNaviBarRightItem);

var getLocation;
if (isWeb) {
    if (isWindvane) {
        getLocation = getLocation$a;
    }
    else if (isNebula) {
        getLocation = getLocation$9;
    }
    else if (isFliggy) {
        getLocation = getLocation$8;
    }
    else if (isDingTalk) {
        getLocation = getLocation$7;
    }
    else if (isDingTalkPC) {
        getLocation = getLocation$6;
    }
    else {
        getLocation = getLocation$1;
    }
}
else if (isMini) {
    if (isMiniAli) {
        getLocation = getLocation$5;
    }
    else if (isMiniWx) {
        getLocation = getLocation$4;
    }
    else if (isMiniTt) {
        getLocation = getLocation$3;
    }
}
else if (isMiniweb) {
    getLocation = getLocation$2;
}
if (!getLocation) {
    getLocation = notSupport;
}
var index$f = promisifyApi(getLocation);

var hideTitle;
if (isWeb) {
    if (isWindvane) {
        if (isWebTb) {
            hideTitle = hideTitle$4;
        }
        else if (isWebTm) {
            hideTitle = hideTitle$2;
        }
        else if (isWebYouku) {
            hideTitle = hideTitle$1;
        }
        else if (isWebFm) {
            hideTitle = hideTitle$3;
        }
        else if (isWebCunpartner) {
            hideTitle = hideTitle$4;
        }
        else if (isWebElmc) {
            hideTitle = hideTitle$4;
        }
        else if (isWebIhome) {
            hideTitle = hideTitle$4;
        }
        else if (isWebTphome) {
            hideTitle = hideTitle$4;
        }
        else if (isWebAh) {
            hideTitle = hideTitle$4;
        }
        else if (isWebAlipm) {
            hideTitle = hideTitle$4;
        }
        else {
            hideTitle = notSupport;
        }
    }
    else if (isNebula) {
        hideTitle = notSupport;
    }
    else if (isFliggy) {
        hideTitle = hideTitle$5;
    }
    else if (isDingTalk) {
        hideTitle = notSupport;
    }
    else if (isDingTalkPC) {
        hideTitle = notSupport;
    }
}
else if (isMini) {
    if (isMiniAli) {
        hideTitle = notSupport;
    }
    else if (isMiniWx) {
        hideTitle = notSupport;
    }
    else if (isMiniTt) {
        hideTitle = notSupport;
    }
}
else if (isMiniweb) {
    hideTitle = notSupport;
}
if (!hideTitle) {
    hideTitle = notSupport;
}
var index$e = promisifyApi(hideTitle);

var pauseAudio;
if (isWeb) {
    if (isWindvane) {
        if (isWebTb) {
            pauseAudio = notSupport;
        }
        else {
            pauseAudio = notSupport;
        }
    }
    else if (isNebula) {
        pauseAudio = pauseAudio$1;
    }
    else if (isFliggy) {
        pauseAudio = notSupport;
    }
    else if (isDingTalk) {
        pauseAudio = notSupport;
    }
    else if (isDingTalkPC) {
        pauseAudio = notSupport;
    }
}
else if (isMini) {
    if (isMiniAli) {
        pauseAudio = notSupport;
    }
    else if (isMiniWx) {
        pauseAudio = notSupport;
    }
    else if (isMiniTt) {
        pauseAudio = notSupport;
    }
}
if (!pauseAudio) {
    pauseAudio = notSupport;
}
var index$d = promisifyApi(pauseAudio);

var saveImage;
if (isWeb) {
    if (isWindvane) {
        saveImage = saveImage$5;
    }
    else if (isNebula) {
        saveImage = notSupport;
    }
    else if (isFliggy) {
        saveImage = saveImage$4;
    }
    else if (isDingTalk) {
        saveImage = notSupport;
    }
    else if (isDingTalkPC) {
        saveImage = notSupport;
    }
}
else if (isMini) {
    if (isMiniAli) {
        saveImage = saveImage$3;
    }
    else if (isMiniWx) {
        saveImage = saveImage$2;
    }
    else if (isMiniTt) {
        saveImage = saveImage$1;
    }
}
if (!saveImage) {
    saveImage = notSupport;
}
var index$c = promisifyApi(saveImage);

var setStorage;
if (isWeb) {
    setStorage = setStorage$1;
}
else if (isMini) {
    if (isMiniAli) {
        setStorage = setStorage$4;
    }
    else if (isMiniWx) {
        setStorage = setStorage$3;
    }
    else if (isMiniTt) {
        setStorage = setStorage$2;
    }
}
if (!setStorage) {
    setStorage = notSupport;
}
var index$b = promisifyApi(setStorage);

var showToast;
if (isWeb) {
    if (isWindvane) {
        showToast = showToast$9;
    }
    else if (isNebula) {
        showToast = showToast$8;
    }
    else if (isFliggy) {
        showToast = showToast$7;
    }
    else if (isDingTalk) {
        showToast = showToast$6;
    }
    else if (isDingTalkPC) {
        showToast = showToast$5;
    }
    else {
        showToast = show;
    }
}
else if (isMini) {
    if (isMiniAli) {
        showToast = showToast$4;
    }
    else if (isMiniWx) {
        showToast = showToast$3;
    }
    else if (isMiniTt) {
        showToast = showToast$2;
    }
}
else if (isMiniweb) {
    showToast = showToast$1;
}
if (!showToast) {
    showToast = notSupport;
}
var index$a = promisifyApi(showToast);

var clearStorage;
if (isWeb) {
    if (isWindvane) {
        clearStorage = notSupport;
    }
    else if (isNebula) {
        clearStorage = notSupport;
    }
    else if (isFliggy) {
        clearStorage = notSupport;
    }
    else if (isDingTalk) {
        clearStorage = notSupport;
    }
    else if (isDingTalkPC) {
        clearStorage = notSupport;
    }
}
else if (isMini) {
    if (isMiniAli) {
        clearStorage = clearStorage$3;
    }
    else if (isMiniWx) {
        clearStorage = clearStorage$2;
    }
    else if (isMiniTt) {
        clearStorage = clearStorage$1;
    }
}
if (!clearStorage) {
    clearStorage = notSupport;
}
var index$9 = promisifyApi(clearStorage);

var clearStorageSync;
if (isWeb) {
    if (isWindvane) {
        clearStorageSync = notSupport;
    }
    else if (isNebula) {
        clearStorageSync = notSupport;
    }
    else if (isFliggy) {
        clearStorageSync = notSupport;
    }
    else if (isDingTalk) {
        clearStorageSync = notSupport;
    }
    else if (isDingTalkPC) {
        clearStorageSync = notSupport;
    }
}
else if (isMini) {
    if (isMiniAli) {
        clearStorageSync = clearStorageSync$4;
    }
    else if (isMiniWx) {
        clearStorageSync = clearStorageSync$3;
    }
    else if (isMiniTt) {
        clearStorageSync = clearStorageSync$2;
    }
}
if (!clearStorageSync) {
    clearStorageSync = notSupport;
}
var clearStorageSync$1 = clearStorageSync;

var getNetworkType;
if (isWeb) {
    if (isWindvane) {
        getNetworkType = getNetworkType$a;
    }
    else if (isNebula) {
        getNetworkType = getNetworkType$9;
    }
    else if (isFliggy) {
        getNetworkType = getNetworkType$8;
    }
    else if (isDingTalk) {
        getNetworkType = getNetworkType$7;
    }
    else if (isDingTalkPC) {
        getNetworkType = getNetworkType$6;
    }
    else {
        getNetworkType = getNetworkType$1;
    }
}
else if (isMini) {
    if (isMiniAli) {
        getNetworkType = getNetworkType$5;
    }
    else if (isMiniWx) {
        getNetworkType = getNetworkType$4;
    }
    else if (isMiniTt) {
        getNetworkType = getNetworkType$3;
    }
}
else if (isMiniweb) {
    getNetworkType = getNetworkType$2;
}
if (!getNetworkType) {
    getNetworkType = notSupport;
}
var index$8 = promisifyApi(getNetworkType);

var hideToast;
if (isWeb) {
    if (isWindvane) {
        hideToast = notSupport;
    }
    else if (isNebula) {
        hideToast = notSupport;
    }
    else if (isFliggy) {
        hideToast = notSupport;
    }
    else if (isDingTalk) {
        hideToast = notSupport;
    }
    else if (isDingTalkPC) {
        hideToast = notSupport;
    }
    else {
        hideToast = hide;
    }
}
else if (isMini) {
    if (isMiniAli) {
        hideToast = hideToast$4;
    }
    else if (isMiniWx) {
        hideToast = hideToast$3;
    }
    else if (isMiniTt) {
        hideToast = hideToast$2;
    }
}
else if (isMiniweb) {
    hideToast = hideToast$1;
}
if (!hideToast) {
    hideToast = notSupport;
}
var index$7 = promisifyApi(hideToast);

var playAudio;
if (isWeb) {
    if (isWindvane) {
        if (isWebTb) {
            playAudio = playAudio$1;
        }
        else if (isWebLt) {
            playAudio = playAudio$1;
        }
        else {
            playAudio = notSupport;
        }
    }
    else if (isNebula) {
        playAudio = playAudio$2;
    }
    else if (isFliggy) {
        playAudio = notSupport;
    }
    else if (isDingTalk) {
        playAudio = notSupport;
    }
    else if (isDingTalkPC) {
        playAudio = notSupport;
    }
}
else if (isMini) {
    if (isMiniAli) {
        playAudio = notSupport;
    }
    else if (isMiniWx) {
        playAudio = notSupport;
    }
    else if (isMiniTt) {
        playAudio = notSupport;
    }
}
if (!playAudio) {
    playAudio = notSupport;
}
var index$6 = promisifyApi(playAudio);

var scan;
if (isWeb) {
    if (isWindvane) {
        if (isWebTb) {
            scan = scan$3;
        }
        else if (isWebFm) {
            scan = scan$3;
        }
        else if (isWebWdkhema) {
            scan = scan$2;
        }
        else if (isWebCunpartner) {
            scan = scan$1;
        }
        else if (isWebLt) {
            scan = scan$3;
        }
        else if (isWebElmc) {
            scan = scan$3;
        }
        else if (isWebIhome) {
            scan = scan$3;
        }
        else if (isWebTphome) {
            scan = scan$3;
        }
        else if (isWebTm) {
            scan = scan$3;
        }
        else if (isWebAlipm) {
            scan = scan$3;
        }
        else {
            scan = notSupport;
        }
    }
    else if (isNebula) {
        scan = scan$b;
    }
    else if (isFliggy) {
        scan = scan$a;
    }
    else if (isDingTalk) {
        scan = scan$9;
    }
    else if (isDingTalkPC) {
        scan = scan$8;
    }
}
else if (isMini) {
    if (isMiniAli) {
        scan = scan$7;
    }
    else if (isMiniWx) {
        scan = scan$6;
    }
    else if (isMiniTt) {
        scan = scan$5;
    }
}
else if (isMiniweb) {
    scan = scan$4;
}
if (!scan) {
    scan = notSupport;
}
var index$5 = promisifyApi(scan);

var setStorageSync;
if (isWeb) {
    setStorageSync = setStorageSync$2;
}
else if (isMini) {
    if (isMiniAli) {
        setStorageSync = setStorageSync$5;
    }
    else if (isMiniWx) {
        setStorageSync = setStorageSync$4;
    }
    else if (isMiniTt) {
        setStorageSync = setStorageSync$3;
    }
}
if (!setStorageSync) {
    setStorageSync = notSupport;
}
var setStorageSync$1 = setStorageSync;

var snapshot;
if (isWeb) {
    if (isWindvane) {
        snapshot = snapshot$3;
    }
    else if (isNebula) {
        snapshot = snapshot$2;
    }
    else if (isFliggy) {
        snapshot = snapshot$1;
    }
    else if (isDingTalk) {
        snapshot = notSupport;
    }
    else if (isDingTalkPC) {
        snapshot = notSupport;
    }
}
else if (isMini) {
    if (isMiniAli) {
        snapshot = notSupport;
    }
    else if (isMiniWx) {
        snapshot = notSupport;
    }
    else if (isMiniTt) {
        snapshot = notSupport;
    }
}
else if (isMiniweb) {
    snapshot = notSupport;
}
if (!snapshot) {
    snapshot = notSupport;
}
var index$4 = promisifyApi(snapshot);

var alert;
if (isWeb) {
    if (isWindvane) {
        alert = alert$a;
    }
    else if (isNebula) {
        alert = alert$9;
    }
    else if (isFliggy) {
        alert = alert$8;
    }
    else if (isDingTalk) {
        alert = alert$7;
    }
    else if (isDingTalkPC) {
        alert = alert$6;
    }
    else {
        alert = alert$1;
    }
}
else if (isMini) {
    if (isMiniAli) {
        alert = alert$5;
    }
    else if (isMiniWx) {
        alert = alert$4;
    }
    else if (isMiniTt) {
        alert = alert$3;
    }
}
else if (isMiniweb) {
    alert = alert$2;
}
if (!alert) {
    alert = notSupport;
}
var index$3 = promisifyApi(alert);

var getOrientation;
if (isWeb) {
    if (isWindvane) {
        getOrientation = getOrientation$3;
    }
    else if (isNebula) {
        getOrientation = notSupport;
    }
    else if (isFliggy) {
        getOrientation = notSupport;
    }
    else if (isDingTalk) {
        getOrientation = notSupport;
    }
    else if (isDingTalkPC) {
        getOrientation = notSupport;
    }
}
else if (isMini) {
    if (isMiniAli) {
        getOrientation = notSupport;
    }
    else if (isMiniWx) {
        getOrientation = getOrientation$2;
    }
    else if (isMiniTt) {
        getOrientation = getOrientation$1;
    }
}
else if (isMiniweb) {
    getOrientation = notSupport;
}
if (!getOrientation) {
    getOrientation = notSupport;
}
var index$2 = promisifyApi(getOrientation);

var previewImage;
if (isWeb) {
    if (isWindvane) {
        if (isWebTb) {
            previewImage = previewImage$2;
        }
        else if (isWebFm) {
            previewImage = previewImage$2;
        }
        else if (isWebWdkhema) {
            previewImage = previewImage$1;
        }
        else if (isWebCunpartner) {
            previewImage = previewImage$2;
        }
        else if (isWebLt) {
            previewImage = previewImage$2;
        }
        else if (isWebElmc) {
            previewImage = previewImage$2;
        }
        else if (isWebIhome) {
            previewImage = previewImage$2;
        }
        else if (isWebTphome) {
            previewImage = previewImage$2;
        }
        else if (isWebAh) {
            previewImage = previewImage$2;
        }
        else if (isWebAlipm) {
            previewImage = previewImage$2;
        }
        else {
            previewImage = notSupport;
        }
    }
    else if (isNebula) {
        previewImage = previewImage$9;
    }
    else if (isFliggy) {
        previewImage = notSupport;
    }
    else if (isDingTalk) {
        previewImage = previewImage$8;
    }
    else if (isDingTalkPC) {
        previewImage = previewImage$7;
    }
}
else if (isMini) {
    if (isMiniAli) {
        previewImage = previewImage$6;
    }
    else if (isMiniWx) {
        previewImage = previewImage$5;
    }
    else if (isMiniTt) {
        previewImage = previewImage$4;
    }
}
else if (isMiniweb) {
    previewImage = previewImage$3;
}
if (!previewImage) {
    previewImage = notSupport;
}
var index$1 = promisifyApi(previewImage);

var getStatusBarHeight;
if (isWeb) {
    if (isWindvane) {
        if (isWebTb) {
            getStatusBarHeight = getStatusBarHeight$2;
        }
        else if (isWebFm) {
            getStatusBarHeight = getStatusBarHeight$1;
        }
        else {
            getStatusBarHeight = getStatusBarHeight$5;
        }
    }
    else if (isNebula) {
        getStatusBarHeight = getStatusBarHeight$4;
    }
    else if (isFliggy) {
        getStatusBarHeight = getStatusBarHeight$3;
    }
    else if (isDingTalk) {
        getStatusBarHeight = notSupport;
    }
    else if (isDingTalkPC) {
        getStatusBarHeight = notSupport;
    }
}
else if (isMini) {
    if (isMiniAli) {
        getStatusBarHeight = notSupport;
    }
    else if (isMiniWx) {
        getStatusBarHeight = notSupport;
    }
    else if (isMiniTt) {
        getStatusBarHeight = notSupport;
    }
}
if (!getStatusBarHeight) {
    getStatusBarHeight = notSupport;
}
var index = promisifyApi(getStatusBarHeight);

export { index$5 as A, index$q as B, index$E as C, index$4 as D, index$v as E, index$o as F, index$f as G, index$8 as H, index$c as I, index$u as J, index$1 as K, index$a as L, index$7 as M, index$D as N, index$t as O, index$3 as P, index$I as Q, index$L as R, index$x as S, index$g as T, index$i as U, index$e as V, index$M as W, index$H as X, index$b as Y, index$y as Z, index$9 as a, index$A as b, clearStorageSync$1 as c, index$n as d, index$2 as e, index as f, getStorageSync$1 as g, index$m as h, index$B as i, index$d as j, index$6 as k, index$k as l, index$r as m, index$j as n, index$w as o, index$K as p, index$C as q, removeStorageSync$1 as r, setStorageSync$1 as s, index$p as t, index$h as u, index$s as v, index$z as w, index$F as x, index$l as y, index$G as z };
